
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9591"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9591"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jPx3Q", function(module, exports) {

$parcel$export(module.exports, "__spreadValues", function () { return $e6fc6cfc0cbc8bdb$export$7de063a7aa429f6c; });
$parcel$export(module.exports, "__spreadProps", function () { return $e6fc6cfc0cbc8bdb$export$f4da8f157c1253f7; });
$parcel$export(module.exports, "__decorateClass", function () { return $e6fc6cfc0cbc8bdb$export$85c93885f16e8446; });
$parcel$export(module.exports, "__privateGet", function () { return $e6fc6cfc0cbc8bdb$export$18a094aefa070634; });
$parcel$export(module.exports, "__privateAdd", function () { return $e6fc6cfc0cbc8bdb$export$addf369becd23283; });
$parcel$export(module.exports, "__privateSet", function () { return $e6fc6cfc0cbc8bdb$export$42432efe6614d3b4; });
$parcel$export(module.exports, "__yieldStar", function () { return $e6fc6cfc0cbc8bdb$export$5590fd18e5672c2; });
var $e6fc6cfc0cbc8bdb$var$__defProp = Object.defineProperty;
var $e6fc6cfc0cbc8bdb$var$__defProps = Object.defineProperties;
var $e6fc6cfc0cbc8bdb$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $e6fc6cfc0cbc8bdb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e6fc6cfc0cbc8bdb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e6fc6cfc0cbc8bdb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e6fc6cfc0cbc8bdb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e6fc6cfc0cbc8bdb$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $e6fc6cfc0cbc8bdb$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $e6fc6cfc0cbc8bdb$var$__defNormalProp = (obj, key, value)=>key in obj ? $e6fc6cfc0cbc8bdb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e6fc6cfc0cbc8bdb$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($e6fc6cfc0cbc8bdb$var$__hasOwnProp.call(b, prop)) $e6fc6cfc0cbc8bdb$var$__defNormalProp(a, prop, b[prop]);
    if ($e6fc6cfc0cbc8bdb$var$__getOwnPropSymbols) {
        for (var prop of $e6fc6cfc0cbc8bdb$var$__getOwnPropSymbols(b))if ($e6fc6cfc0cbc8bdb$var$__propIsEnum.call(b, prop)) $e6fc6cfc0cbc8bdb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e6fc6cfc0cbc8bdb$export$f4da8f157c1253f7 = (a, b)=>$e6fc6cfc0cbc8bdb$var$__defProps(a, $e6fc6cfc0cbc8bdb$var$__getOwnPropDescs(b));
var $e6fc6cfc0cbc8bdb$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $e6fc6cfc0cbc8bdb$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $e6fc6cfc0cbc8bdb$var$__defProp(target, key, result);
    return result;
};
var $e6fc6cfc0cbc8bdb$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $e6fc6cfc0cbc8bdb$var$__typeError("Cannot " + msg);
var $e6fc6cfc0cbc8bdb$export$18a094aefa070634 = (obj, member, getter)=>($e6fc6cfc0cbc8bdb$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $e6fc6cfc0cbc8bdb$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $e6fc6cfc0cbc8bdb$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $e6fc6cfc0cbc8bdb$export$42432efe6614d3b4 = (obj, member, value, setter)=>($e6fc6cfc0cbc8bdb$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $e6fc6cfc0cbc8bdb$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $e6fc6cfc0cbc8bdb$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$e6fc6cfc0cbc8bdb$var$__knownSymbol("asyncIterator")], isAwait = false, method, it = {};
    if (obj == null) {
        obj = value[$e6fc6cfc0cbc8bdb$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $e6fc6cfc0cbc8bdb$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) $e6fc6cfc0cbc8bdb$var$__typeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$e6fc6cfc0cbc8bdb$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};

});

parcelRegister("c69rD", function(module, exports) {

$parcel$export(module.exports, "formCollections", function () { return $8ced5f1619d8e1aa$export$61a522b559454891; });
$parcel$export(module.exports, "FormControlController", function () { return $8ced5f1619d8e1aa$export$43da334182d34ab4; });
$parcel$export(module.exports, "validValidityState", function () { return $8ced5f1619d8e1aa$export$6c5960ddf0f5ff89; });
$parcel$export(module.exports, "valueMissingValidityState", function () { return $8ced5f1619d8e1aa$export$bd584164a4d1886c; });
$parcel$export(module.exports, "customErrorValidityState", function () { return $8ced5f1619d8e1aa$export$d17679f2bc5863d4; });

var $jPx3Q = parcelRequire("jPx3Q");
// src/internal/form.ts
var $8ced5f1619d8e1aa$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $8ced5f1619d8e1aa$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $8ced5f1619d8e1aa$var$checkValidityOverloads = /* @__PURE__ */ new WeakMap();
var $8ced5f1619d8e1aa$var$userInteractedControls = /* @__PURE__ */ new WeakSet();
var $8ced5f1619d8e1aa$var$interactions = /* @__PURE__ */ new WeakMap();
var $8ced5f1619d8e1aa$export$43da334182d34ab4 = class {
    constructor(host, options){
        this.handleFormData = (event)=>{
            const disabled = this.options.disabled(this.host);
            const name = this.options.name(this.host);
            const value = this.options.value(this.host);
            const isButton = this.host.tagName.toLowerCase() === "sl-button";
            if (this.host.isConnected && !disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
                if (Array.isArray(value)) value.forEach((val)=>{
                    event.formData.append(name, val.toString());
                });
                else event.formData.append(name, value.toString());
            }
        };
        this.handleFormSubmit = (event)=>{
            var _a;
            const disabled = this.options.disabled(this.host);
            const reportValidity = this.options.reportValidity;
            if (this.form && !this.form.noValidate) (_a = $8ced5f1619d8e1aa$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
                this.setUserInteracted(control, true);
            });
            if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleFormReset = ()=>{
            this.options.setValue(this.host, this.options.defaultValue(this.host));
            this.setUserInteracted(this.host, false);
            $8ced5f1619d8e1aa$var$interactions.set(this.host, []);
        };
        this.handleInteraction = (event)=>{
            const emittedEvents = $8ced5f1619d8e1aa$var$interactions.get(this.host);
            if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
            if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
        };
        this.checkFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.checkValidity === "function") {
                    if (!element.checkValidity()) return false;
                }
            }
            return true;
        };
        this.reportFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.reportValidity === "function") {
                    if (!element.reportValidity()) return false;
                }
            }
            return true;
        };
        (this.host = host).addController(this);
        this.options = (0, $jPx3Q.__spreadValues)({
            form: (input)=>{
                const formId = input.form;
                if (formId) {
                    const root = input.getRootNode();
                    const form = root.querySelector(`#${formId}`);
                    if (form) return form;
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            checkValidity: (input)=>typeof input.checkValidity === "function" ? input.checkValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $8ced5f1619d8e1aa$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $8ced5f1619d8e1aa$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($8ced5f1619d8e1aa$export$61a522b559454891.has(this.form)) $8ced5f1619d8e1aa$export$61a522b559454891.get(this.form).add(this.host);
            else $8ced5f1619d8e1aa$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$8ced5f1619d8e1aa$var$reportValidityOverloads.has(this.form)) {
                $8ced5f1619d8e1aa$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
            if (!$8ced5f1619d8e1aa$var$checkValidityOverloads.has(this.form)) {
                $8ced5f1619d8e1aa$var$checkValidityOverloads.set(this.form, this.form.checkValidity);
                this.form.checkValidity = ()=>this.checkFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        if (!this.form) return;
        const formCollection = $8ced5f1619d8e1aa$export$61a522b559454891.get(this.form);
        if (!formCollection) return;
        formCollection.delete(this.host);
        if (formCollection.size <= 0) {
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($8ced5f1619d8e1aa$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $8ced5f1619d8e1aa$var$reportValidityOverloads.get(this.form);
                $8ced5f1619d8e1aa$var$reportValidityOverloads.delete(this.form);
            }
            if ($8ced5f1619d8e1aa$var$checkValidityOverloads.has(this.form)) {
                this.form.checkValidity = $8ced5f1619d8e1aa$var$checkValidityOverloads.get(this.form);
                $8ced5f1619d8e1aa$var$checkValidityOverloads.delete(this.form);
            }
            this.form = void 0;
        }
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $8ced5f1619d8e1aa$var$userInteractedControls.add(el);
        else $8ced5f1619d8e1aa$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, submitter) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (submitter) {
                button.name = submitter.name;
                button.value = submitter.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (submitter.hasAttribute(attr)) button.setAttribute(attr, submitter.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(submitter) {
        this.doAction("reset", submitter);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(submitter) {
        this.doAction("submit", submitter);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($8ced5f1619d8e1aa$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $8ced5f1619d8e1aa$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $8ced5f1619d8e1aa$export$bd584164a4d1886c = Object.freeze((0, $jPx3Q.__spreadProps)((0, $jPx3Q.__spreadValues)({}, $8ced5f1619d8e1aa$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $8ced5f1619d8e1aa$export$d17679f2bc5863d4 = Object.freeze((0, $jPx3Q.__spreadProps)((0, $jPx3Q.__spreadValues)({}, $8ced5f1619d8e1aa$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));

});

var $267028be646caeef$exports = {};
$parcel$extendImportMap({
    "3FXHE": "chat-left-dots.17c9ba62.svg",
    "ddR3g": "exclamation-circle.87e77183.svg",
    "620Gg": "share.35971ac4.svg",
    "fm3cC": "arrow-repeat.177ce82e.svg",
    "uCCWe": "event_available.da056bc0.svg",
    "5ccv0": "health_and_safety.cd6d5774.svg",
    "2kW7X": "medication.d23f4f68.svg"
});

// Set the base path to the folder you copied Shoelace's assets to
// src/utilities/base-path.ts
var $23fda3427ed4fc44$var$basePath = "";
function $23fda3427ed4fc44$export$784ad41d332938c6(path) {
    $23fda3427ed4fc44$var$basePath = path;
}
function $23fda3427ed4fc44$export$9099264ed9b1c55a(subpath = "") {
    if (!$23fda3427ed4fc44$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $23fda3427ed4fc44$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>{
                return /shoelace(\.min)?\.js($|\?)/.test(s.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(s.src);
            });
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $23fda3427ed4fc44$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $23fda3427ed4fc44$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}


parcelRequire("jPx3Q");


// src/components/card/card.styles.ts
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8d6d220e4f43fd73$var$t = globalThis, $8d6d220e4f43fd73$export$b4d10f6001c083c2 = $8d6d220e4f43fd73$var$t.ShadowRoot && (void 0 === $8d6d220e4f43fd73$var$t.ShadyCSS || $8d6d220e4f43fd73$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $8d6d220e4f43fd73$var$s = Symbol(), $8d6d220e4f43fd73$var$o = new WeakMap;
class $8d6d220e4f43fd73$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $8d6d220e4f43fd73$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($8d6d220e4f43fd73$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $8d6d220e4f43fd73$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $8d6d220e4f43fd73$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $8d6d220e4f43fd73$export$8d80f9cac07cdb3 = (t)=>new $8d6d220e4f43fd73$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $8d6d220e4f43fd73$var$s), $8d6d220e4f43fd73$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $8d6d220e4f43fd73$export$505d1e8739bad805(o, t, $8d6d220e4f43fd73$var$s);
}, $8d6d220e4f43fd73$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($8d6d220e4f43fd73$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $8d6d220e4f43fd73$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $8d6d220e4f43fd73$export$ee69dfd951e24778 = $8d6d220e4f43fd73$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $8d6d220e4f43fd73$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $dff49d944d9c7f91$var$i, defineProperty: $dff49d944d9c7f91$var$e, getOwnPropertyDescriptor: $dff49d944d9c7f91$var$h, getOwnPropertyNames: $dff49d944d9c7f91$var$r, getOwnPropertySymbols: $dff49d944d9c7f91$var$o, getPrototypeOf: $dff49d944d9c7f91$var$n } = Object, $dff49d944d9c7f91$var$a = globalThis, $dff49d944d9c7f91$var$c = $dff49d944d9c7f91$var$a.trustedTypes, $dff49d944d9c7f91$var$l = $dff49d944d9c7f91$var$c ? $dff49d944d9c7f91$var$c.emptyScript : "", $dff49d944d9c7f91$var$p = $dff49d944d9c7f91$var$a.reactiveElementPolyfillSupport, $dff49d944d9c7f91$var$d = (t, s)=>t, $dff49d944d9c7f91$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $dff49d944d9c7f91$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $dff49d944d9c7f91$export$53a6892c50694894 = (t, s)=>!$dff49d944d9c7f91$var$i(t, s), $dff49d944d9c7f91$var$b = {
    attribute: !0,
    type: String,
    converter: $dff49d944d9c7f91$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $dff49d944d9c7f91$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $dff49d944d9c7f91$var$a.litPropertyMetadata ??= new WeakMap;
class $dff49d944d9c7f91$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $dff49d944d9c7f91$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $dff49d944d9c7f91$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $dff49d944d9c7f91$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $dff49d944d9c7f91$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($dff49d944d9c7f91$var$d("elementProperties"))) return;
        const t = $dff49d944d9c7f91$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($dff49d944d9c7f91$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($dff49d944d9c7f91$var$d("properties"))) {
            const t = this.properties, s = [
                ...$dff49d944d9c7f91$var$r(t),
                ...$dff49d944d9c7f91$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $8d6d220e4f43fd73$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $8d6d220e4f43fd73$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $8d6d220e4f43fd73$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $dff49d944d9c7f91$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $dff49d944d9c7f91$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $dff49d944d9c7f91$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$dff49d944d9c7f91$export$c7c07a37856565d.elementStyles = [], $dff49d944d9c7f91$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $dff49d944d9c7f91$export$c7c07a37856565d[$dff49d944d9c7f91$var$d("elementProperties")] = new Map, $dff49d944d9c7f91$export$c7c07a37856565d[$dff49d944d9c7f91$var$d("finalized")] = new Map, $dff49d944d9c7f91$var$p?.({
    ReactiveElement: $dff49d944d9c7f91$export$c7c07a37856565d
}), ($dff49d944d9c7f91$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $57a4cdd7772d1b51$var$t = globalThis, $57a4cdd7772d1b51$var$i = (t)=>t, $57a4cdd7772d1b51$var$s = $57a4cdd7772d1b51$var$t.trustedTypes, $57a4cdd7772d1b51$var$e = $57a4cdd7772d1b51$var$s ? $57a4cdd7772d1b51$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $57a4cdd7772d1b51$var$h = "$lit$", $57a4cdd7772d1b51$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $57a4cdd7772d1b51$var$n = "?" + $57a4cdd7772d1b51$var$o, $57a4cdd7772d1b51$var$r = `<${$57a4cdd7772d1b51$var$n}>`, $57a4cdd7772d1b51$var$l = document, $57a4cdd7772d1b51$var$c = ()=>$57a4cdd7772d1b51$var$l.createComment(""), $57a4cdd7772d1b51$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $57a4cdd7772d1b51$var$u = Array.isArray, $57a4cdd7772d1b51$var$d = (t)=>$57a4cdd7772d1b51$var$u(t) || "function" == typeof t?.[Symbol.iterator], $57a4cdd7772d1b51$var$f = "[ \t\n\f\r]", $57a4cdd7772d1b51$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $57a4cdd7772d1b51$var$_ = /-->/g, $57a4cdd7772d1b51$var$m = />/g, $57a4cdd7772d1b51$var$p = RegExp(`>|${$57a4cdd7772d1b51$var$f}(?:([^\\s"'>=/]+)(${$57a4cdd7772d1b51$var$f}*=${$57a4cdd7772d1b51$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $57a4cdd7772d1b51$var$g = /'/g, $57a4cdd7772d1b51$var$$ = /"/g, $57a4cdd7772d1b51$var$y = /^(?:script|style|textarea|title)$/i, $57a4cdd7772d1b51$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $57a4cdd7772d1b51$export$c0bb0b647f701bb5 = $57a4cdd7772d1b51$var$x(1), $57a4cdd7772d1b51$export$7ed1367e7fa1ad68 = $57a4cdd7772d1b51$var$x(2), $57a4cdd7772d1b51$export$47d5b44d225be5b4 = $57a4cdd7772d1b51$var$x(3), $57a4cdd7772d1b51$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $57a4cdd7772d1b51$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $57a4cdd7772d1b51$var$C = new WeakMap, $57a4cdd7772d1b51$var$P = $57a4cdd7772d1b51$var$l.createTreeWalker($57a4cdd7772d1b51$var$l, 129);
function $57a4cdd7772d1b51$var$V(t, i) {
    if (!$57a4cdd7772d1b51$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $57a4cdd7772d1b51$var$e ? $57a4cdd7772d1b51$var$e.createHTML(i) : i;
}
const $57a4cdd7772d1b51$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $57a4cdd7772d1b51$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $57a4cdd7772d1b51$var$v ? "!--" === u[1] ? c = $57a4cdd7772d1b51$var$_ : void 0 !== u[1] ? c = $57a4cdd7772d1b51$var$m : void 0 !== u[2] ? ($57a4cdd7772d1b51$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $57a4cdd7772d1b51$var$p) : void 0 !== u[3] && (c = $57a4cdd7772d1b51$var$p) : c === $57a4cdd7772d1b51$var$p ? ">" === u[0] ? (c = n ?? $57a4cdd7772d1b51$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $57a4cdd7772d1b51$var$p : '"' === u[3] ? $57a4cdd7772d1b51$var$$ : $57a4cdd7772d1b51$var$g) : c === $57a4cdd7772d1b51$var$$ || c === $57a4cdd7772d1b51$var$g ? c = $57a4cdd7772d1b51$var$p : c === $57a4cdd7772d1b51$var$_ || c === $57a4cdd7772d1b51$var$m ? c = $57a4cdd7772d1b51$var$v : (c = $57a4cdd7772d1b51$var$p, n = void 0);
        const x = c === $57a4cdd7772d1b51$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $57a4cdd7772d1b51$var$v ? s + $57a4cdd7772d1b51$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $57a4cdd7772d1b51$var$h + s.slice(d) + $57a4cdd7772d1b51$var$o + x) : s + $57a4cdd7772d1b51$var$o + (-2 === d ? i : x);
    }
    return [
        $57a4cdd7772d1b51$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $57a4cdd7772d1b51$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $57a4cdd7772d1b51$var$N(t, i);
        if (this.el = $57a4cdd7772d1b51$var$S.createElement(f, e), $57a4cdd7772d1b51$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $57a4cdd7772d1b51$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($57a4cdd7772d1b51$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($57a4cdd7772d1b51$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $57a4cdd7772d1b51$var$I : "?" === e[1] ? $57a4cdd7772d1b51$var$L : "@" === e[1] ? $57a4cdd7772d1b51$var$z : $57a4cdd7772d1b51$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($57a4cdd7772d1b51$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($57a4cdd7772d1b51$var$y.test(r.tagName)) {
                    const t = r.textContent.split($57a4cdd7772d1b51$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $57a4cdd7772d1b51$var$s ? $57a4cdd7772d1b51$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $57a4cdd7772d1b51$var$c()), $57a4cdd7772d1b51$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $57a4cdd7772d1b51$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $57a4cdd7772d1b51$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($57a4cdd7772d1b51$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $57a4cdd7772d1b51$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $57a4cdd7772d1b51$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $57a4cdd7772d1b51$var$M(t, i, s = t, e) {
    if (i === $57a4cdd7772d1b51$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $57a4cdd7772d1b51$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $57a4cdd7772d1b51$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $57a4cdd7772d1b51$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $57a4cdd7772d1b51$var$l).importNode(i, !0);
        $57a4cdd7772d1b51$var$P.currentNode = e;
        let h = $57a4cdd7772d1b51$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $57a4cdd7772d1b51$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $57a4cdd7772d1b51$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $57a4cdd7772d1b51$var$P.nextNode(), o++);
        }
        return $57a4cdd7772d1b51$var$P.currentNode = $57a4cdd7772d1b51$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $57a4cdd7772d1b51$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $57a4cdd7772d1b51$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $57a4cdd7772d1b51$var$M(this, t, i), $57a4cdd7772d1b51$var$a(t) ? t === $57a4cdd7772d1b51$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $57a4cdd7772d1b51$export$45b790e32b2810ee && this._$AR(), this._$AH = $57a4cdd7772d1b51$export$45b790e32b2810ee) : t !== this._$AH && t !== $57a4cdd7772d1b51$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $57a4cdd7772d1b51$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $57a4cdd7772d1b51$export$45b790e32b2810ee && $57a4cdd7772d1b51$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($57a4cdd7772d1b51$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $57a4cdd7772d1b51$var$S.createElement($57a4cdd7772d1b51$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $57a4cdd7772d1b51$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $57a4cdd7772d1b51$var$C.get(t.strings);
        return void 0 === i && $57a4cdd7772d1b51$var$C.set(t.strings, i = new $57a4cdd7772d1b51$var$S(t)), i;
    }
    k(t) {
        $57a4cdd7772d1b51$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $57a4cdd7772d1b51$var$k(this.O($57a4cdd7772d1b51$var$c()), this.O($57a4cdd7772d1b51$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $57a4cdd7772d1b51$var$i(t).nextSibling;
            $57a4cdd7772d1b51$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $57a4cdd7772d1b51$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $57a4cdd7772d1b51$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $57a4cdd7772d1b51$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $57a4cdd7772d1b51$var$M(this, t, i, 0), o = !$57a4cdd7772d1b51$var$a(t) || t !== this._$AH && t !== $57a4cdd7772d1b51$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $57a4cdd7772d1b51$var$M(this, e[s + n], i, n), r === $57a4cdd7772d1b51$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$57a4cdd7772d1b51$var$a(r) || r !== this._$AH[n], r === $57a4cdd7772d1b51$export$45b790e32b2810ee ? t = $57a4cdd7772d1b51$export$45b790e32b2810ee : t !== $57a4cdd7772d1b51$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $57a4cdd7772d1b51$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $57a4cdd7772d1b51$var$I extends $57a4cdd7772d1b51$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $57a4cdd7772d1b51$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $57a4cdd7772d1b51$var$L extends $57a4cdd7772d1b51$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $57a4cdd7772d1b51$export$45b790e32b2810ee);
    }
}
class $57a4cdd7772d1b51$var$z extends $57a4cdd7772d1b51$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $57a4cdd7772d1b51$var$M(this, t, i, 0) ?? $57a4cdd7772d1b51$export$45b790e32b2810ee) === $57a4cdd7772d1b51$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $57a4cdd7772d1b51$export$45b790e32b2810ee && s !== $57a4cdd7772d1b51$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $57a4cdd7772d1b51$export$45b790e32b2810ee && (s === $57a4cdd7772d1b51$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $57a4cdd7772d1b51$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $57a4cdd7772d1b51$var$M(this, t);
    }
}
const $57a4cdd7772d1b51$export$8613d1ca9052b22e = {
    M: $57a4cdd7772d1b51$var$h,
    P: $57a4cdd7772d1b51$var$o,
    A: $57a4cdd7772d1b51$var$n,
    C: 1,
    L: $57a4cdd7772d1b51$var$N,
    R: $57a4cdd7772d1b51$var$R,
    D: $57a4cdd7772d1b51$var$d,
    V: $57a4cdd7772d1b51$var$M,
    I: $57a4cdd7772d1b51$var$k,
    H: $57a4cdd7772d1b51$var$H,
    N: $57a4cdd7772d1b51$var$L,
    U: $57a4cdd7772d1b51$var$z,
    B: $57a4cdd7772d1b51$var$I,
    F: $57a4cdd7772d1b51$var$Z
}, $57a4cdd7772d1b51$var$B = $57a4cdd7772d1b51$var$t.litHtmlPolyfillSupport;
$57a4cdd7772d1b51$var$B?.($57a4cdd7772d1b51$var$S, $57a4cdd7772d1b51$var$k), ($57a4cdd7772d1b51$var$t.litHtmlVersions ??= []).push("3.3.3");
const $57a4cdd7772d1b51$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $57a4cdd7772d1b51$var$k(i.insertBefore($57a4cdd7772d1b51$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1798c95797f8aa05$var$s = globalThis;
class $1798c95797f8aa05$export$3f2f9f5909897157 extends (0, $dff49d944d9c7f91$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $57a4cdd7772d1b51$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $57a4cdd7772d1b51$export$9c068ae9cc5db4e8;
    }
}
$1798c95797f8aa05$export$3f2f9f5909897157._$litElement$ = !0, $1798c95797f8aa05$export$3f2f9f5909897157["finalized"] = !0, $1798c95797f8aa05$var$s.litElementHydrateSupport?.({
    LitElement: $1798c95797f8aa05$export$3f2f9f5909897157
});
const $1798c95797f8aa05$var$o = $1798c95797f8aa05$var$s.litElementPolyfillSupport;
$1798c95797f8aa05$var$o?.({
    LitElement: $1798c95797f8aa05$export$3f2f9f5909897157
});
const $1798c95797f8aa05$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($1798c95797f8aa05$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e86b8cc6d74f8a8e$export$6acf61af03e62db = !1;




var $00b0dd7919316af4$export$eceb153d0f9bbd93 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    --border-color: var(--sl-color-neutral-200);
    --border-radius: var(--sl-border-radius-medium);
    --border-width: 1px;
    --padding: var(--sl-spacing-large);

    display: inline-block;
  }

  .card {
    display: flex;
    flex-direction: column;
    background-color: var(--sl-panel-background-color);
    box-shadow: var(--sl-shadow-x-small);
    border: solid var(--border-width) var(--border-color);
    border-radius: var(--border-radius);
  }

  .card__image {
    display: flex;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    margin: calc(-1 * var(--border-width));
    overflow: hidden;
  }

  .card__image::slotted(img) {
    display: block;
    width: 100%;
  }

  .card:not(.card--has-image) .card__image {
    display: none;
  }

  .card__header {
    display: block;
    border-bottom: solid var(--border-width) var(--border-color);
    padding: calc(var(--padding) / 2) var(--padding);
  }

  .card:not(.card--has-header) .card__header {
    display: none;
  }

  .card:not(.card--has-image) .card__header {
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
  }

  .card__body {
    display: block;
    padding: var(--padding);
  }

  .card--has-footer .card__footer {
    display: block;
    border-top: solid var(--border-width) var(--border-color);
    padding: var(--padding);
  }

  .card:not(.card--has-footer) .card__footer {
    display: none;
  }
`;


// src/internal/slot.ts
var $134116549af3fc49$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        this.handleSlotChange = (event)=>{
            const slot = event.target;
            if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
};
function $134116549af3fc49$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}


// src/styles/component.styles.ts

var $e141b099bccd29d3$export$e1ac0a3ec62d1269 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;



var $jPx3Q = parcelRequire("jPx3Q");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $496744d9b4569d46$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b5e2ce8348041b43$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $dff49d944d9c7f91$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $dff49d944d9c7f91$export$53a6892c50694894)
}, $b5e2ce8348041b43$export$8d623b1670eb40f4 = (t = $b5e2ce8348041b43$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $b5e2ce8348041b43$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $b5e2ce8348041b43$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d707a3c650256db3$export$ca000e230c0caa3e(r) {
    return (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $79d97cd93a34c8f1$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $eeb040129e46212c$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $815172d2438addea$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $eeb040129e46212c$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $eeb040129e46212c$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $13f01e3bc15c5a8c$var$e;
function $13f01e3bc15c5a8c$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $eeb040129e46212c$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($13f01e3bc15c5a8c$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $11b279c75fade4b4$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $eeb040129e46212c$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $33b873255ee5b04c$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $eeb040129e46212c$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d288110b7cb9ce3a$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $eeb040129e46212c$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




var $2787ba9f20b771ed$var$_hasRecordedInitialProperties;
var $2787ba9f20b771ed$export$6f25236e887097b = class extends (0, $1798c95797f8aa05$export$3f2f9f5909897157) {
    constructor(){
        super();
        (0, $jPx3Q.__privateAdd)(this, $2787ba9f20b771ed$var$_hasRecordedInitialProperties, false);
        // Store the constructor value of all `static properties = {}`
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $jPx3Q.__spreadValues)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options);
            } catch (_err) {
                customElements.define(name, class extends elementConstructor {
                }, options);
            }
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $jPx3Q.__privateGet)(this, $2787ba9f20b771ed$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $jPx3Q.__privateSet)(this, $2787ba9f20b771ed$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
};
$2787ba9f20b771ed$var$_hasRecordedInitialProperties = new WeakMap();
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$2787ba9f20b771ed$export$6f25236e887097b.version = "2.20.1";
$2787ba9f20b771ed$export$6f25236e887097b.dependencies = {};
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $2787ba9f20b771ed$export$6f25236e887097b.prototype, "dir", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $2787ba9f20b771ed$export$6f25236e887097b.prototype, "lang", 2);



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $615be63a54463998$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $615be63a54463998$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $615be63a54463998$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $11177c62ab91de50$export$56cc687933817664 = (0, $615be63a54463998$export$99b43ad1ed32e735)(class extends (0, $615be63a54463998$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $615be63a54463998$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $57a4cdd7772d1b51$export$9c068ae9cc5db4e8;
    }
});





var $3066e8610267fc7e$export$a93c76cb301d0cc8 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "footer", "header", "image");
    }
    render() {
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            card: true,
            "card--has-footer": this.hasSlotController.test("footer"),
            "card--has-image": this.hasSlotController.test("image"),
            "card--has-header": this.hasSlotController.test("header")
        })}
      >
        <slot name="image" part="image" class="card__image"></slot>
        <slot name="header" part="header" class="card__header"></slot>
        <slot part="body" class="card__body"></slot>
        <slot name="footer" part="footer" class="card__footer"></slot>
      </div>
    `;
    }
};
$3066e8610267fc7e$export$a93c76cb301d0cc8.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $00b0dd7919316af4$export$eceb153d0f9bbd93)
];


// src/components/card/card.ts
var $fab8bf927c15c13c$export$4630804d47451d56 = (0, $3066e8610267fc7e$export$a93c76cb301d0cc8);
(0, $3066e8610267fc7e$export$a93c76cb301d0cc8).define("sl-card");







parcelRequire("jPx3Q");



// src/components/icon/library.default.ts
var $18c8543145bb6f8b$var$library = {
    name: "default",
    resolver: (name)=>(0, $23fda3427ed4fc44$export$9099264ed9b1c55a)(`assets/icons/${name}.svg`)
};
var $18c8543145bb6f8b$export$761783e099ce3526 = $18c8543145bb6f8b$var$library;


// src/components/icon/library.system.ts
var $fbaeb10ec66ddfbe$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $fbaeb10ec66ddfbe$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $fbaeb10ec66ddfbe$var$icons) return `data:image/svg+xml,${encodeURIComponent($fbaeb10ec66ddfbe$var$icons[name])}`;
        return "";
    }
};
var $fbaeb10ec66ddfbe$export$3139252f9828970f = $fbaeb10ec66ddfbe$var$systemLibrary;


// src/components/icon/library.ts
var $822265300b544663$var$registry = [
    (0, $18c8543145bb6f8b$export$761783e099ce3526),
    (0, $fbaeb10ec66ddfbe$export$3139252f9828970f)
];
var $822265300b544663$var$watchedIcons = [];
function $822265300b544663$export$da63f424a7208010(icon) {
    $822265300b544663$var$watchedIcons.push(icon);
}
function $822265300b544663$export$9e46b25ecab82f0b(icon) {
    $822265300b544663$var$watchedIcons = $822265300b544663$var$watchedIcons.filter((el)=>el !== icon);
}
function $822265300b544663$export$be026de5111f322b(name) {
    return $822265300b544663$var$registry.find((lib)=>lib.name === name);
}
function $822265300b544663$export$a482e04ad60c9b11(name, options) {
    $822265300b544663$export$8faa256e94012669(name);
    $822265300b544663$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $822265300b544663$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $822265300b544663$export$8faa256e94012669(name) {
    $822265300b544663$var$registry = $822265300b544663$var$registry.filter((lib)=>lib.name !== name);
}


// src/components/icon/icon.styles.ts

var $02d2cde72fc4cfd8$export$f0b0874d64866432 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;



var $jPx3Q = parcelRequire("jPx3Q");
// src/internal/watch.ts
function $f62429163a881570$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $jPx3Q.__spreadValues)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}





var $jPx3Q = parcelRequire("jPx3Q");


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $f257c6251dfd8e62$var$t } = (0, $57a4cdd7772d1b51$export$8613d1ca9052b22e), $f257c6251dfd8e62$var$i = (o)=>o, $f257c6251dfd8e62$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $f257c6251dfd8e62$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $f257c6251dfd8e62$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $f257c6251dfd8e62$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $f257c6251dfd8e62$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $f257c6251dfd8e62$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $f257c6251dfd8e62$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $f257c6251dfd8e62$var$s = ()=>document.createComment(""), $f257c6251dfd8e62$export$291b2338ad9b0b30 = (o, n, e)=>{
    const l = o._$AA.parentNode, d = void 0 === n ? o._$AB : n._$AA;
    if (void 0 === e) {
        const i = l.insertBefore($f257c6251dfd8e62$var$s(), d), n = l.insertBefore($f257c6251dfd8e62$var$s(), d);
        e = new $f257c6251dfd8e62$var$t(i, n, o, o.options);
    } else {
        const t = e._$AB.nextSibling, n = e._$AM, c = n !== o;
        if (c) {
            let t;
            e._$AQ?.(o), e._$AM = o, void 0 !== e._$AP && (t = o._$AU) !== n._$AU && e._$AP(t);
        }
        if (t !== d || c) {
            let o = e._$AA;
            for(; o !== t;){
                const t = $f257c6251dfd8e62$var$i(o).nextSibling;
                $f257c6251dfd8e62$var$i(l).insertBefore(o, d), o = t;
            }
        }
    }
    return e;
}, $f257c6251dfd8e62$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $f257c6251dfd8e62$var$m = {}, $f257c6251dfd8e62$export$ea70d9dd5965b1c8 = (o, t = $f257c6251dfd8e62$var$m)=>o._$AH = t, $f257c6251dfd8e62$export$59e9bce518cde500 = (o)=>o._$AH, $f257c6251dfd8e62$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $f257c6251dfd8e62$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};





var $41c94d63aaf9231c$var$CACHEABLE_ERROR = Symbol();
var $41c94d63aaf9231c$var$RETRYABLE_ERROR = Symbol();
var $41c94d63aaf9231c$var$parser;
var $41c94d63aaf9231c$var$iconCache = /* @__PURE__ */ new Map();
var $41c94d63aaf9231c$export$ef62a86bf282441 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.initialRender = false;
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        var _a;
        let fileData;
        if (library == null ? void 0 : library.spriteSheet) {
            this.svg = (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
            return this.svg;
        }
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $41c94d63aaf9231c$var$CACHEABLE_ERROR : $41c94d63aaf9231c$var$RETRYABLE_ERROR;
        } catch (e) {
            return $41c94d63aaf9231c$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (((_a = svg == null ? void 0 : svg.tagName) == null ? void 0 : _a.toLowerCase()) !== "svg") return $41c94d63aaf9231c$var$CACHEABLE_ERROR;
            if (!$41c94d63aaf9231c$var$parser) $41c94d63aaf9231c$var$parser = new DOMParser();
            const doc = $41c94d63aaf9231c$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $41c94d63aaf9231c$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch (e) {
            return $41c94d63aaf9231c$var$CACHEABLE_ERROR;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $822265300b544663$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.initialRender = true;
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $822265300b544663$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $822265300b544663$export$be026de5111f322b)(this.library);
        if (this.name && library) return {
            url: library.resolver(this.name),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $822265300b544663$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $41c94d63aaf9231c$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $41c94d63aaf9231c$var$iconCache.set(url, iconResolver);
        }
        if (!this.initialRender) return;
        const svg = await iconResolver;
        if (svg === $41c94d63aaf9231c$var$RETRYABLE_ERROR) $41c94d63aaf9231c$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $f257c6251dfd8e62$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            if (library) {
                await this.updateComplete;
                const shadowSVG = this.shadowRoot.querySelector("[part='svg']");
                if (typeof library.mutator === "function" && shadowSVG) library.mutator(shadowSVG);
            }
            return;
        }
        switch(svg){
            case $41c94d63aaf9231c$var$RETRYABLE_ERROR:
            case $41c94d63aaf9231c$var$CACHEABLE_ERROR:
                this.svg = null;
                this.emit("sl-error");
                break;
            default:
                this.svg = svg.cloneNode(true);
                (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, this.svg);
                this.emit("sl-load");
        }
    }
    render() {
        return this.svg;
    }
};
$41c94d63aaf9231c$export$ef62a86bf282441.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $02d2cde72fc4cfd8$export$f0b0874d64866432)
];
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "svg", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "src", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "label", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "library", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("label")
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $41c94d63aaf9231c$export$ef62a86bf282441.prototype, "setIcon", 1);


// src/components/icon/icon.ts
var $a9bc4127f0428cc9$export$21036209a317fcec = (0, $41c94d63aaf9231c$export$ef62a86bf282441);
(0, $41c94d63aaf9231c$export$ef62a86bf282441).define("sl-icon");











parcelRequire("jPx3Q");


// src/components/spinner/spinner.styles.ts

var $c119ca3b5f6ee466$export$6a9ed4d91972acb3 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`;


// src/translations/en.ts
const $f40b01a464741426$var$connectedElements = new Set();
const $f40b01a464741426$var$translations = new Map();
let $f40b01a464741426$var$fallback;
let $f40b01a464741426$var$documentDirection = 'ltr';
let $f40b01a464741426$var$documentLanguage = 'en';
const $f40b01a464741426$var$isClient = typeof MutationObserver !== 'undefined' && typeof document !== 'undefined' && typeof document.documentElement !== 'undefined';
if ($f40b01a464741426$var$isClient) {
    const documentElementObserver = new MutationObserver($f40b01a464741426$export$722fbec263ad908a);
    $f40b01a464741426$var$documentDirection = document.documentElement.dir || 'ltr';
    $f40b01a464741426$var$documentLanguage = document.documentElement.lang || navigator.language;
    documentElementObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [
            'dir',
            'lang'
        ]
    });
}
function $f40b01a464741426$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($f40b01a464741426$var$translations.has(code)) $f40b01a464741426$var$translations.set(code, Object.assign(Object.assign({}, $f40b01a464741426$var$translations.get(code)), t));
        else $f40b01a464741426$var$translations.set(code, t);
        if (!$f40b01a464741426$var$fallback) $f40b01a464741426$var$fallback = t;
    });
    $f40b01a464741426$export$722fbec263ad908a();
}
function $f40b01a464741426$export$722fbec263ad908a() {
    if ($f40b01a464741426$var$isClient) {
        $f40b01a464741426$var$documentDirection = document.documentElement.dir || 'ltr';
        $f40b01a464741426$var$documentLanguage = document.documentElement.lang || navigator.language;
    }
    [
        ...$f40b01a464741426$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === 'function') el.requestUpdate();
    });
}
class $f40b01a464741426$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $f40b01a464741426$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $f40b01a464741426$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $f40b01a464741426$var$documentDirection}`.toLowerCase();
    }
    lang() {
        const lang = `${this.host.lang || $f40b01a464741426$var$documentLanguage}`.toLowerCase().replace(/_/g, '-');
        try {
            new Intl.Locale(lang);
            return lang;
        } catch (_a) {
            return $f40b01a464741426$var$fallback ? $f40b01a464741426$var$fallback.$code.toLowerCase() : 'en';
        }
    }
    getTranslationData(lang) {
        var _a, _b;
        let locale;
        try {
            locale = new Intl.Locale(lang.replace(/_/g, '-'));
        } catch (_c) {
            return {
                locale: undefined,
                language: '',
                region: '',
                primary: undefined,
                secondary: undefined
            };
        }
        const language = locale.language.toLowerCase();
        const region = (_b = (_a = locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        const primary = $f40b01a464741426$var$translations.get(`${language}-${region}`);
        const secondary = $f40b01a464741426$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $f40b01a464741426$var$fallback && $f40b01a464741426$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($f40b01a464741426$var$fallback && $f40b01a464741426$var$fallback[key]) term = $f40b01a464741426$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === 'function') return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? '' : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $3d7dc9e8e4bbc6cb$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format"
};
(0, $f40b01a464741426$export$2332cb3ce32cc839)($3d7dc9e8e4bbc6cb$var$translation);
var $3d7dc9e8e4bbc6cb$export$802b895dc4aecf21 = $3d7dc9e8e4bbc6cb$var$translation;



var $a8a344465f70fe58$export$b1a2fed5bb41b893 = class extends (0, $f40b01a464741426$export$b1a2fed5bb41b893) {
};
(0, $f40b01a464741426$export$2332cb3ce32cc839)((0, $3d7dc9e8e4bbc6cb$export$802b895dc4aecf21));





var $dd3f7aba48cff428$export$4e45ce56e46d2b00 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $a8a344465f70fe58$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$dd3f7aba48cff428$export$4e45ce56e46d2b00.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $c119ca3b5f6ee466$export$6a9ed4d91972acb3)
];



var $c69rD = parcelRequire("c69rD");
// src/components/button/button.styles.ts

var $2075f4fbb46a0d40$export$172eea9c07ee1ffd = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host([data-sl-button-group__button--first]:not([data-sl-button-group__button--last])) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host([data-sl-button-group__button--inner]) .button {
    border-radius: 0;
  }

  :host([data-sl-button-group__button--last]:not([data-sl-button-group__button--first])) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host([data-sl-button-group__button]:not([data-sl-button-group__button--first])) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      [data-sl-button-group__button]:not(
          [data-sl-button-group__button--first],
          [data-sl-button-group__button--radio],
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host([data-sl-button-group__button--hover]) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host([data-sl-button-group__button--focus]),
  :host([data-sl-button-group__button][checked]) {
    z-index: 2;
  }
`;









var $jPx3Q = parcelRequire("jPx3Q");


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0bfedcd8831cfe58$var$a = Symbol.for(""), $0bfedcd8831cfe58$var$o = (t)=>{
    if (t?.r === $0bfedcd8831cfe58$var$a) return t?._$litStatic$;
}, $0bfedcd8831cfe58$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $0bfedcd8831cfe58$var$a
    }), $0bfedcd8831cfe58$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, a)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[a + 1], t[0]),
        r: $0bfedcd8831cfe58$var$a
    }), $0bfedcd8831cfe58$var$l = new Map, $0bfedcd8831cfe58$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const a = e.length;
        let s, i;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < a;){
            for(c = r[$]; $ < a && void 0 !== (i = e[$], s = $0bfedcd8831cfe58$var$o(i));)c += s + r[++$], f = !0;
            $ !== a && u.push(i), n.push(c), $++;
        }
        if ($ === a && n.push(r[a]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $0bfedcd8831cfe58$var$l.get(t)) && (n.raw = n, $0bfedcd8831cfe58$var$l.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $0bfedcd8831cfe58$export$c0bb0b647f701bb5 = $0bfedcd8831cfe58$export$878791788f808fc0((0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)), $0bfedcd8831cfe58$export$7ed1367e7fa1ad68 = $0bfedcd8831cfe58$export$878791788f808fc0((0, $57a4cdd7772d1b51$export$7ed1367e7fa1ad68)), $0bfedcd8831cfe58$export$47d5b44d225be5b4 = $0bfedcd8831cfe58$export$878791788f808fc0((0, $57a4cdd7772d1b51$export$47d5b44d225be5b4));





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $597a805efc9ad164$export$f68dd208b5df064d = (o)=>o ?? (0, $57a4cdd7772d1b51$export$45b790e32b2810ee);





var $16fbb381c6bab4cb$export$e56d306ebf763f31 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $c69rD.FormControlController)(this, {
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $a8a344465f70fe58$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $c69rD.validValidityState;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $0bfedcd8831cfe58$export$c8ec6e1ec9fefcb0)`a` : (0, $0bfedcd8831cfe58$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $0bfedcd8831cfe58$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : this.name)}
        value=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : this.value)}
        href=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink && !this.disabled ? this.href : void 0)}
        target=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? this.rel : void 0)}
        role=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $0bfedcd8831cfe58$export$c0bb0b647f701bb5)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $0bfedcd8831cfe58$export$c0bb0b647f701bb5)`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$16fbb381c6bab4cb$export$e56d306ebf763f31.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $2075f4fbb46a0d40$export$172eea9c07ee1ffd)
];
$16fbb381c6bab4cb$export$e56d306ebf763f31.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441),
    "sl-spinner": (0, $dd3f7aba48cff428$export$4e45ce56e46d2b00)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".button")
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "button", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "title", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "type", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "href", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "target", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "download", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "form", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "formaction"
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "formenctype"
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "formmethod"
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "formtarget"
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $16fbb381c6bab4cb$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);


// src/components/button/button.ts
var $40281d6104525984$export$11c362adf4e83e40 = (0, $16fbb381c6bab4cb$export$e56d306ebf763f31);
(0, $16fbb381c6bab4cb$export$e56d306ebf763f31).define("sl-button");





parcelRequire("c69rD");













parcelRequire("jPx3Q");


// src/components/icon-button/icon-button.styles.ts

var $5756cf8d750c4a37$export$e7174f10cedebf49 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;






var $jPx3Q = parcelRequire("jPx3Q");




var $7c81203c9668765b$export$302c9d29315a4659 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $0bfedcd8831cfe58$export$c8ec6e1ec9fefcb0)`a` : (0, $0bfedcd8831cfe58$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $0bfedcd8831cfe58$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        href=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.name)}
          library=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.library)}
          src=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$7c81203c9668765b$export$302c9d29315a4659.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $5756cf8d750c4a37$export$e7174f10cedebf49)
];
$7c81203c9668765b$export$302c9d29315a4659.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".icon-button")
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "button", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "library", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "src", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "href", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "target", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "download", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "label", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7c81203c9668765b$export$302c9d29315a4659.prototype, "disabled", 2);


// src/components/icon-button/icon-button.ts
var $4301c7b15dd99400$export$9189df4c7423e03f = (0, $7c81203c9668765b$export$302c9d29315a4659);
(0, $7c81203c9668765b$export$302c9d29315a4659).define("sl-icon-button");













parcelRequire("jPx3Q");


// src/components/input/input.styles.ts

var $3cfc399d2de46f57$export$c3b7146590bd78c8 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`;


// src/internal/default-value.ts

var $b27873656deb6259$export$1a01ae0705bafd37 = (propertyName = "value")=>(proto, key)=>{
        const ctor = proto.constructor;
        const attributeChangedCallback = ctor.prototype.attributeChangedCallback;
        ctor.prototype.attributeChangedCallback = function(name, old, value) {
            var _a;
            const options = ctor.getPropertyOptions(propertyName);
            const attributeName = typeof options.attribute === "string" ? options.attribute : propertyName;
            if (name === attributeName) {
                const converter = options.converter || (0, $dff49d944d9c7f91$export$7312b35fbf521afb);
                const fromAttribute = typeof converter === "function" ? converter : (_a = converter == null ? void 0 : converter.fromAttribute) != null ? _a : (0, $dff49d944d9c7f91$export$7312b35fbf521afb).fromAttribute;
                const newValue = fromAttribute(value, options.type);
                if (this[propertyName] !== newValue) this[key] = newValue;
            }
            attributeChangedCallback.call(this, name, old, value);
        };
    };


// src/styles/form-control.styles.ts

var $fc719b2fd5802da3$export$e7c8528c268605e9 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`;



var $c69rD = parcelRequire("c69rD");







var $jPx3Q = parcelRequire("jPx3Q");






/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc5d598867de3edb$export$28cf49ad70f82d12 = (0, $615be63a54463998$export$99b43ad1ed32e735)(class extends (0, $615be63a54463998$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $615be63a54463998$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $615be63a54463998$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $615be63a54463998$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $f257c6251dfd8e62$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $57a4cdd7772d1b51$export$9c068ae9cc5db4e8) || t === (0, $57a4cdd7772d1b51$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $615be63a54463998$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $57a4cdd7772d1b51$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $615be63a54463998$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $57a4cdd7772d1b51$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $615be63a54463998$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $57a4cdd7772d1b51$export$9c068ae9cc5db4e8;
        return (0, $f257c6251dfd8e62$export$ea70d9dd5965b1c8)(i), t;
    }
});





var $17f2ad7c4b8d9c62$export$bf759620d4db2643 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $c69rD.FormControlController)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.localize = new (0, $a8a344465f70fe58$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.title = "";
        // make reactive to pass through
        this.__numberInput = Object.assign(document.createElement("input"), {
            type: "number"
        });
        this.__dateInput = Object.assign(document.createElement("input"), {
            type: "date"
        });
        this.type = "text";
        this.name = "";
        this.value = "";
        this.defaultValue = "";
        this.size = "medium";
        this.filled = false;
        this.pill = false;
        this.label = "";
        this.helpText = "";
        this.clearable = false;
        this.disabled = false;
        this.placeholder = "";
        this.readonly = false;
        this.passwordToggle = false;
        this.passwordVisible = false;
        this.noSpinButtons = false;
        this.form = "";
        this.required = false;
        this.spellcheck = true;
    }
    //
    // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
    // can be set before the component is rendered.
    //
    /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */ get valueAsDate() {
        var _a;
        this.__dateInput.type = this.type;
        this.__dateInput.value = this.value;
        return ((_a = this.input) == null ? void 0 : _a.valueAsDate) || this.__dateInput.valueAsDate;
    }
    set valueAsDate(newValue) {
        this.__dateInput.type = this.type;
        this.__dateInput.valueAsDate = newValue;
        this.value = this.__dateInput.value;
    }
    /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */ get valueAsNumber() {
        var _a;
        this.__numberInput.value = this.value;
        return ((_a = this.input) == null ? void 0 : _a.valueAsNumber) || this.__numberInput.valueAsNumber;
    }
    set valueAsNumber(newValue) {
        this.__numberInput.valueAsNumber = newValue;
        this.value = this.__numberInput.value;
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleChange() {
        this.value = this.input.value;
        this.emit("sl-change");
    }
    handleClearClick(event) {
        event.preventDefault();
        if (this.value !== "") {
            this.value = "";
            this.emit("sl-clear");
            this.emit("sl-input");
            this.emit("sl-change");
        }
        this.input.focus();
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleInput() {
        this.value = this.input.value;
        this.formControlController.updateValidity();
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleKeyDown(event) {
        const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        if (event.key === "Enter" && !hasModifier) setTimeout(()=>{
            if (!event.defaultPrevented && !event.isComposing) this.formControlController.submit();
        });
    }
    handlePasswordToggle() {
        this.passwordVisible = !this.passwordVisible;
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleStepChange() {
        this.input.step = String(this.step);
        this.formControlController.updateValidity();
    }
    async handleValueChange() {
        await this.updateComplete;
        this.formControlController.updateValidity();
    }
    /** Sets focus on the input. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the input. */ blur() {
        this.input.blur();
    }
    /** Selects all the text in the input. */ select() {
        this.input.select();
    }
    /** Sets the start and end positions of the text selection (0-based). */ setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
        this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    /** Replaces a range of text with a new string. */ setRangeText(replacement, start, end, selectMode = "preserve") {
        const selectionStart = start != null ? start : this.input.selectionStart;
        const selectionEnd = end != null ? end : this.input.selectionEnd;
        this.input.setRangeText(replacement, selectionStart, selectionEnd, selectMode);
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */ showPicker() {
        if ("showPicker" in HTMLInputElement.prototype) this.input.showPicker();
    }
    /** Increments the value of a numeric input type by the value of the step attribute. */ stepUp() {
        this.input.stepUp();
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Decrements the value of a numeric input type by the value of the step attribute. */ stepDown() {
        this.input.stepDown();
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const hasClearIcon = this.clearable && !this.disabled && !this.readonly;
        const isClearIconVisible = hasClearIcon && (typeof this.value === "number" || this.value.length > 0);
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${hasLabel ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            input: true,
            // Sizes
            "input--small": this.size === "small",
            "input--medium": this.size === "medium",
            "input--large": this.size === "large",
            // States
            "input--pill": this.pill,
            "input--standard": !this.filled,
            "input--filled": this.filled,
            "input--disabled": this.disabled,
            "input--focused": this.hasFocus,
            "input--empty": !this.value,
            "input--no-spin-buttons": this.noSpinButtons
        })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.placeholder)}
              minlength=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.minlength)}
              maxlength=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.maxlength)}
              min=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.min)}
              max=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.max)}
              step=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.step)}
              .value=${(0, $cc5d598867de3edb$export$28cf49ad70f82d12)(this.value)}
              autocapitalize=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.autocapitalize)}
              autocomplete=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.autocomplete)}
              autocorrect=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.pattern)}
              enterkeyhint=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.enterkeyhint)}
              inputmode=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${isClearIconVisible ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$17f2ad7c4b8d9c62$export$bf759620d4db2643.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $fc719b2fd5802da3$export$e7c8528c268605e9),
    (0, $3cfc399d2de46f57$export$c3b7146590bd78c8)
];
$17f2ad7c4b8d9c62$export$bf759620d4db2643.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".input__control")
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "input", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "title", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "type", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b27873656deb6259$export$1a01ae0705bafd37)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "defaultValue", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "filled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "pill", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "label", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "helpText", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "clearable", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "placeholder", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "readonly", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "password-toggle",
        type: Boolean
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "passwordToggle", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "password-visible",
        type: Boolean
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "passwordVisible", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "no-spin-buttons",
        type: Boolean
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "noSpinButtons", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "form", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "required", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "pattern", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "minlength", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "maxlength", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "min", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "max", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "step", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "autocapitalize", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "autocorrect", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "autocomplete", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "autofocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "enterkeyhint", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        converter: {
            // Allow "true|false" attribute values but keep the property boolean
            fromAttribute: (value)=>!value || value === "false" ? false : true,
            toAttribute: (value)=>value ? "true" : "false"
        }
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "spellcheck", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "inputmode", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "handleDisabledChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("step", {
        waitUntilFirstUpdate: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "handleStepChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("value", {
        waitUntilFirstUpdate: true
    })
], $17f2ad7c4b8d9c62$export$bf759620d4db2643.prototype, "handleValueChange", 1);


// src/components/input/input.ts
var $a5f9e2c156ba24fc$export$921a3451e53aa4ce = (0, $17f2ad7c4b8d9c62$export$bf759620d4db2643);
(0, $17f2ad7c4b8d9c62$export$bf759620d4db2643).define("sl-input");






parcelRequire("c69rD");












parcelRequire("jPx3Q");


// src/components/radio-group/radio-group.styles.ts

var $acb1140b2604344d$export$3132e473b9b2813a = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .form-control {
    position: relative;
    border: none;
    padding: 0;
    margin: 0;
  }

  .form-control__label {
    padding: 0;
  }

  .radio-group--required .radio-group__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;



// src/components/button-group/button-group.styles.ts

var $3ccf212566437a7b$export$72ced8e32474b4fe = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .button-group {
    display: flex;
    flex-wrap: nowrap;
  }
`;





var $jPx3Q = parcelRequire("jPx3Q");


var $b3870e9a2a4b43b3$export$da1d95f84eaf247e = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.disableRole = false;
        this.label = "";
    }
    handleFocus(event) {
        const button = $b3870e9a2a4b43b3$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--focus", true);
    }
    handleBlur(event) {
        const button = $b3870e9a2a4b43b3$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--focus", false);
    }
    handleMouseOver(event) {
        const button = $b3870e9a2a4b43b3$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--hover", true);
    }
    handleMouseOut(event) {
        const button = $b3870e9a2a4b43b3$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--hover", false);
    }
    handleSlotChange() {
        const slottedElements = [
            ...this.defaultSlot.assignedElements({
                flatten: true
            })
        ];
        slottedElements.forEach((el)=>{
            const index = slottedElements.indexOf(el);
            const button = $b3870e9a2a4b43b3$var$findButton(el);
            if (button) {
                button.toggleAttribute("data-sl-button-group__button", true);
                button.toggleAttribute("data-sl-button-group__button--first", index === 0);
                button.toggleAttribute("data-sl-button-group__button--inner", index > 0 && index < slottedElements.length - 1);
                button.toggleAttribute("data-sl-button-group__button--last", index === slottedElements.length - 1);
                button.toggleAttribute("data-sl-button-group__button--radio", button.tagName.toLowerCase() === "sl-radio-button");
            }
        });
    }
    render() {
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class="button-group"
        role="${this.disableRole ? "presentation" : "group"}"
        aria-label=${this.label}
        @focusout=${this.handleBlur}
        @focusin=${this.handleFocus}
        @mouseover=${this.handleMouseOver}
        @mouseout=${this.handleMouseOut}
      >
        <slot @slotchange=${this.handleSlotChange}></slot>
      </div>
    `;
    }
};
$b3870e9a2a4b43b3$export$da1d95f84eaf247e.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $3ccf212566437a7b$export$72ced8e32474b4fe)
];
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)("slot")
], $b3870e9a2a4b43b3$export$da1d95f84eaf247e.prototype, "defaultSlot", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $b3870e9a2a4b43b3$export$da1d95f84eaf247e.prototype, "disableRole", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b3870e9a2a4b43b3$export$da1d95f84eaf247e.prototype, "label", 2);
function $b3870e9a2a4b43b3$var$findButton(el) {
    var _a;
    const selector = "sl-button, sl-radio-button";
    return (_a = el.closest(selector)) != null ? _a : el.querySelector(selector);
}



var $c69rD = parcelRequire("c69rD");





var $jPx3Q = parcelRequire("jPx3Q");



var $b57c8ae58d07ad15$export$b359e2a027ddff66 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $c69rD.FormControlController)(this);
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.customValidityMessage = "";
        this.hasButtonGroup = false;
        this.errorMessage = "";
        this.defaultValue = "";
        this.label = "";
        this.helpText = "";
        this.name = "option";
        this.value = "";
        this.size = "medium";
        this.form = "";
        this.required = false;
    }
    /** Gets the validity state object */ get validity() {
        const isRequiredAndEmpty = this.required && !this.value;
        const hasCustomValidityMessage = this.customValidityMessage !== "";
        if (hasCustomValidityMessage) return 0, $c69rD.customErrorValidityState;
        else if (isRequiredAndEmpty) return 0, $c69rD.valueMissingValidityState;
        return 0, $c69rD.validValidityState;
    }
    /** Gets the validation message */ get validationMessage() {
        const isRequiredAndEmpty = this.required && !this.value;
        const hasCustomValidityMessage = this.customValidityMessage !== "";
        if (hasCustomValidityMessage) return this.customValidityMessage;
        else if (isRequiredAndEmpty) return this.validationInput.validationMessage;
        return "";
    }
    connectedCallback() {
        super.connectedCallback();
        this.defaultValue = this.value;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    getAllRadios() {
        return [
            ...this.querySelectorAll("sl-radio, sl-radio-button")
        ];
    }
    handleRadioClick(event) {
        const target = event.target.closest("sl-radio, sl-radio-button");
        const radios = this.getAllRadios();
        const oldValue = this.value;
        if (!target || target.disabled) return;
        this.value = target.value;
        radios.forEach((radio)=>radio.checked = radio === target);
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleKeyDown(event) {
        var _a;
        if (![
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight",
            " "
        ].includes(event.key)) return;
        const radios = this.getAllRadios().filter((radio)=>!radio.disabled);
        const checkedRadio = (_a = radios.find((radio)=>radio.checked)) != null ? _a : radios[0];
        const incr = event.key === " " ? 0 : [
            "ArrowUp",
            "ArrowLeft"
        ].includes(event.key) ? -1 : 1;
        const oldValue = this.value;
        let index = radios.indexOf(checkedRadio) + incr;
        if (index < 0) index = radios.length - 1;
        if (index > radios.length - 1) index = 0;
        this.getAllRadios().forEach((radio)=>{
            radio.checked = false;
            if (!this.hasButtonGroup) radio.setAttribute("tabindex", "-1");
        });
        this.value = radios[index].value;
        radios[index].checked = true;
        if (!this.hasButtonGroup) {
            radios[index].setAttribute("tabindex", "0");
            radios[index].focus();
        } else radios[index].shadowRoot.querySelector("button").focus();
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
        event.preventDefault();
    }
    handleLabelClick() {
        this.focus();
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    async syncRadioElements() {
        var _a, _b;
        const radios = this.getAllRadios();
        await Promise.all(// Sync the checked state and size
        radios.map(async (radio)=>{
            await radio.updateComplete;
            radio.checked = radio.value === this.value;
            radio.size = this.size;
        }));
        this.hasButtonGroup = radios.some((radio)=>radio.tagName.toLowerCase() === "sl-radio-button");
        if (radios.length > 0 && !radios.some((radio)=>radio.checked)) {
            if (this.hasButtonGroup) {
                const buttonRadio = (_a = radios[0].shadowRoot) == null ? void 0 : _a.querySelector("button");
                if (buttonRadio) buttonRadio.setAttribute("tabindex", "0");
            } else radios[0].setAttribute("tabindex", "0");
        }
        if (this.hasButtonGroup) {
            const buttonGroup = (_b = this.shadowRoot) == null ? void 0 : _b.querySelector("sl-button-group");
            if (buttonGroup) buttonGroup.disableRole = true;
        }
    }
    syncRadios() {
        if (customElements.get("sl-radio") && customElements.get("sl-radio-button")) {
            this.syncRadioElements();
            return;
        }
        if (customElements.get("sl-radio")) this.syncRadioElements();
        else customElements.whenDefined("sl-radio").then(()=>this.syncRadios());
        if (customElements.get("sl-radio-button")) this.syncRadioElements();
        else customElements.whenDefined("sl-radio-button").then(()=>this.syncRadios());
    }
    updateCheckedRadio() {
        const radios = this.getAllRadios();
        radios.forEach((radio)=>radio.checked = radio.value === this.value);
        this.formControlController.setValidity(this.validity.valid);
    }
    handleSizeChange() {
        this.syncRadios();
    }
    handleValueChange() {
        if (this.hasUpdated) this.updateCheckedRadio();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        const isRequiredAndEmpty = this.required && !this.value;
        const hasCustomValidityMessage = this.customValidityMessage !== "";
        if (isRequiredAndEmpty || hasCustomValidityMessage) {
            this.formControlController.emitInvalidEvent();
            return false;
        }
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        const isValid = this.validity.valid;
        this.errorMessage = this.customValidityMessage || isValid ? "" : this.validationInput.validationMessage;
        this.formControlController.setValidity(isValid);
        this.validationInput.hidden = true;
        clearTimeout(this.validationTimeout);
        if (!isValid) {
            this.validationInput.hidden = false;
            this.validationInput.reportValidity();
            this.validationTimeout = setTimeout(()=>this.validationInput.hidden = true, 1e4);
        }
        return isValid;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message = "") {
        this.customValidityMessage = message;
        this.errorMessage = message;
        this.validationInput.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    /** Sets focus on the radio-group. */ focus(options) {
        const radios = this.getAllRadios();
        const checked = radios.find((radio)=>radio.checked);
        const firstEnabledRadio = radios.find((radio)=>!radio.disabled);
        const radioToFocus = checked || firstEnabledRadio;
        if (radioToFocus) radioToFocus.focus(options);
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const defaultSlot = (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <slot @slotchange=${this.syncRadios} @click=${this.handleRadioClick} @keydown=${this.handleKeyDown}></slot>
    `;
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <fieldset
        part="form-control"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--radio-group": true,
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
        role="radiogroup"
        aria-labelledby="label"
        aria-describedby="help-text"
        aria-errormessage="error-message"
      >
        <label
          part="form-control-label"
          id="label"
          class="form-control__label"
          aria-hidden=${hasLabel ? "false" : "true"}
          @click=${this.handleLabelClick}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div class="visually-hidden">
            <div id="error-message" aria-live="assertive">${this.errorMessage}</div>
            <label class="radio-group__validation">
              <input
                type="text"
                class="radio-group__validation-input"
                ?required=${this.required}
                tabindex="-1"
                hidden
                @invalid=${this.handleInvalid}
              />
            </label>
          </div>

          ${this.hasButtonGroup ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                <sl-button-group part="button-group" exportparts="base:button-group__base" role="presentation">
                  ${defaultSlot}
                </sl-button-group>
              ` : defaultSlot}
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </fieldset>
    `;
    }
};
$b57c8ae58d07ad15$export$b359e2a027ddff66.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $fc719b2fd5802da3$export$e7c8528c268605e9),
    (0, $acb1140b2604344d$export$3132e473b9b2813a)
];
$b57c8ae58d07ad15$export$b359e2a027ddff66.dependencies = {
    "sl-button-group": (0, $b3870e9a2a4b43b3$export$da1d95f84eaf247e)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)("slot:not([name])")
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "defaultSlot", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".radio-group__validation-input")
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "validationInput", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "hasButtonGroup", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "errorMessage", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "defaultValue", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "label", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "helpText", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "form", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "required", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("size", {
        waitUntilFirstUpdate: true
    })
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "handleSizeChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("value")
], $b57c8ae58d07ad15$export$b359e2a027ddff66.prototype, "handleValueChange", 1);


// src/components/radio-group/radio-group.ts
var $a1e547ba9946970c$export$cb30f4715ae71f77 = (0, $b57c8ae58d07ad15$export$b359e2a027ddff66);
(0, $b57c8ae58d07ad15$export$b359e2a027ddff66).define("sl-radio-group");







parcelRequire("c69rD");




parcelRequire("jPx3Q");


// src/components/radio/radio.styles.ts

var $694af0aa58c8ccb0$export$b83d32a0e38cb9ea = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  :host(:focus-visible) {
    outline: 0px;
  }

  .radio {
    display: inline-flex;
    align-items: top;
    font-family: var(--sl-input-font-family);
    font-size: var(--sl-input-font-size-medium);
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .radio--small {
    --toggle-size: var(--sl-toggle-size-small);
    font-size: var(--sl-input-font-size-small);
  }

  .radio--medium {
    --toggle-size: var(--sl-toggle-size-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .radio--large {
    --toggle-size: var(--sl-toggle-size-large);
    font-size: var(--sl-input-font-size-large);
  }

  .radio__checked-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  .radio__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: 50%;
    background-color: var(--sl-input-background-color);
    color: transparent;
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
  }

  .radio__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .radio:not(.radio--checked):not(.radio--disabled) .radio__control:hover {
    border-color: var(--sl-input-border-color-hover);
    background-color: var(--sl-input-background-color-hover);
  }

  /* Checked */
  .radio--checked .radio__control {
    color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
  }

  /* Checked + hover */
  .radio.radio--checked:not(.radio--disabled) .radio__control:hover {
    border-color: var(--sl-color-primary-500);
    background-color: var(--sl-color-primary-500);
  }

  /* Checked + focus */
  :host(:focus-visible) .radio__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .radio--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When the control isn't checked, hide the circle for Windows High Contrast mode a11y */
  .radio:not(.radio--checked) svg circle {
    opacity: 0;
  }

  .radio__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }
`;







var $jPx3Q = parcelRequire("jPx3Q");



var $030a708d7c6d971b$export$e4c8f7cbcd0c899c = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super();
        this.checked = false;
        this.hasFocus = false;
        this.size = "medium";
        this.disabled = false;
        this.handleBlur = ()=>{
            this.hasFocus = false;
            this.emit("sl-blur");
        };
        this.handleClick = ()=>{
            if (!this.disabled) this.checked = true;
        };
        this.handleFocus = ()=>{
            this.hasFocus = true;
            this.emit("sl-focus");
        };
        this.addEventListener("blur", this.handleBlur);
        this.addEventListener("click", this.handleClick);
        this.addEventListener("focus", this.handleFocus);
    }
    connectedCallback() {
        super.connectedCallback();
        this.setInitialAttributes();
    }
    setInitialAttributes() {
        this.setAttribute("role", "radio");
        this.setAttribute("tabindex", "-1");
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleCheckedChange() {
        this.setAttribute("aria-checked", this.checked ? "true" : "false");
        this.setAttribute("tabindex", this.checked ? "0" : "-1");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    render() {
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <span
        part="base"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            radio: true,
            "radio--checked": this.checked,
            "radio--disabled": this.disabled,
            "radio--focused": this.hasFocus,
            "radio--small": this.size === "small",
            "radio--medium": this.size === "medium",
            "radio--large": this.size === "large"
        })}
      >
        <span part="${`control${this.checked ? " control--checked" : ""}`}" class="radio__control">
          ${this.checked ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)` <sl-icon part="checked-icon" class="radio__checked-icon" library="system" name="radio"></sl-icon> ` : ""}
        </span>

        <slot part="label" class="radio__label"></slot>
      </span>
    `;
    }
};
$030a708d7c6d971b$export$e4c8f7cbcd0c899c.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $694af0aa58c8ccb0$export$b83d32a0e38cb9ea)
];
$030a708d7c6d971b$export$e4c8f7cbcd0c899c.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441)
};
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "checked", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("checked")
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "handleCheckedChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $030a708d7c6d971b$export$e4c8f7cbcd0c899c.prototype, "handleDisabledChange", 1);


// src/components/radio/radio.ts
var $fa3e3ffae908d436$export$ae409d22c5d3c393 = (0, $030a708d7c6d971b$export$e4c8f7cbcd0c899c);
(0, $030a708d7c6d971b$export$e4c8f7cbcd0c899c).define("sl-radio");













parcelRequire("jPx3Q");




var $3fac5378a5ca88bf$export$b63cf85333bb1d07 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  ${(0, $2075f4fbb46a0d40$export$172eea9c07ee1ffd)}

  .button__prefix,
  .button__suffix,
  .button__label {
    display: inline-flex;
    position: relative;
    align-items: center;
  }

  /* We use a hidden input so constraint validation errors work, since they don't appear to show when used with buttons.
    We can't actually hide it, though, otherwise the messages will be suppressed by the browser. */
  .hidden-input {
    all: unset;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    outline: dotted 1px red;
    opacity: 0;
    z-index: -1;
  }
`;







var $jPx3Q = parcelRequire("jPx3Q");




var $7ab555966418de8e$export$794c9f1b4d1d5e8f = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.hasFocus = false;
        this.checked = false;
        this.disabled = false;
        this.size = "medium";
        this.pill = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "presentation");
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        this.checked = true;
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    /** Sets focus on the radio button. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the radio button. */ blur() {
        this.input.blur();
    }
    render() {
        return (0, $0bfedcd8831cfe58$export$c0bb0b647f701bb5)`
      <div part="base" role="presentation">
        <button
          part="${`button${this.checked ? " button--checked" : ""}`}"
          role="radio"
          aria-checked="${this.checked}"
          class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            button: true,
            "button--default": true,
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--checked": this.checked,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--outline": true,
            "button--pill": this.pill,
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
          aria-disabled=${this.disabled}
          type="button"
          value=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.value)}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
          @click=${this.handleClick}
        >
          <slot name="prefix" part="prefix" class="button__prefix"></slot>
          <slot part="label" class="button__label"></slot>
          <slot name="suffix" part="suffix" class="button__suffix"></slot>
        </button>
      </div>
    `;
    }
};
$7ab555966418de8e$export$794c9f1b4d1d5e8f.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $3fac5378a5ca88bf$export$b63cf85333bb1d07)
];
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".button")
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "input", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".hidden-input")
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "hiddenInput", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "checked", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "pill", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $7ab555966418de8e$export$794c9f1b4d1d5e8f.prototype, "handleDisabledChange", 1);


// src/components/radio-button/radio-button.ts
var $a70961a7ddb592e0$export$19890f28c17acaa1 = (0, $7ab555966418de8e$export$794c9f1b4d1d5e8f);
(0, $7ab555966418de8e$export$794c9f1b4d1d5e8f).define("sl-radio-button");









parcelRequire("jPx3Q");


// src/components/checkbox/checkbox.styles.ts

var $a389eb20a96d5584$export$d780863e08270d06 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .checkbox {
    position: relative;
    display: inline-flex;
    align-items: flex-start;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .checkbox--small {
    --toggle-size: var(--sl-toggle-size-small);
    font-size: var(--sl-input-font-size-small);
  }

  .checkbox--medium {
    --toggle-size: var(--sl-toggle-size-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .checkbox--large {
    --toggle-size: var(--sl-toggle-size-large);
    font-size: var(--sl-input-font-size-large);
  }

  .checkbox__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: 2px;
    background-color: var(--sl-input-background-color);
    color: var(--sl-color-neutral-0);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
  }

  .checkbox__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  .checkbox__checked-icon,
  .checkbox__indeterminate-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  /* Hover */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--sl-input-border-color-hover);
    background-color: var(--sl-input-background-color-hover);
  }

  /* Focus */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked/indeterminate */
  .checkbox--checked .checkbox__control,
  .checkbox--indeterminate .checkbox__control {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
  }

  /* Checked/indeterminate + hover */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__control:hover,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--sl-color-primary-500);
    background-color: var(--sl-color-primary-500);
  }

  /* Checked/indeterminate + focus */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .checkbox--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .checkbox__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .checkbox__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }
`;





var $c69rD = parcelRequire("c69rD");






var $jPx3Q = parcelRequire("jPx3Q");





var $009d7d74a34fb167$export$7f3be6aba957b8f2 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $c69rD.FormControlController)(this, {
            value: (control)=>control.checked ? control.value || "on" : void 0,
            defaultValue: (control)=>control.defaultChecked,
            setValue: (control, checked)=>control.checked = checked
        });
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "help-text");
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.size = "medium";
        this.disabled = false;
        this.checked = false;
        this.indeterminate = false;
        this.defaultChecked = false;
        this.form = "";
        this.required = false;
        this.helpText = "";
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleClick() {
        this.checked = !this.checked;
        this.indeterminate = false;
        this.emit("sl-change");
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleInput() {
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleStateChange() {
        this.input.checked = this.checked;
        this.input.indeterminate = this.indeterminate;
        this.formControlController.updateValidity();
    }
    /** Simulates a click on the checkbox. */ click() {
        this.input.click();
    }
    /** Sets focus on the checkbox. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the checkbox. */ blur() {
        this.input.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /**
   * Sets a custom validation message. The value provided will be shown to the user when the form is submitted. To clear
   * the custom validation message, call this method with an empty string.
   */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="base"
          class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            checkbox: true,
            "checkbox--checked": this.checked,
            "checkbox--disabled": this.disabled,
            "checkbox--focused": this.hasFocus,
            "checkbox--indeterminate": this.indeterminate,
            "checkbox--small": this.size === "small",
            "checkbox--medium": this.size === "medium",
            "checkbox--large": this.size === "large"
        })}
        >
          <input
            class="checkbox__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.value)}
            .indeterminate=${(0, $cc5d598867de3edb$export$28cf49ad70f82d12)(this.indeterminate)}
            .checked=${(0, $cc5d598867de3edb$export$28cf49ad70f82d12)(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
          />

          <span
            part="control${this.checked ? " control--checked" : ""}${this.indeterminate ? " control--indeterminate" : ""}"
            class="checkbox__control"
          >
            ${this.checked ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                  <sl-icon part="checked-icon" class="checkbox__checked-icon" library="system" name="check"></sl-icon>
                ` : ""}
            ${!this.checked && this.indeterminate ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                  <sl-icon
                    part="indeterminate-icon"
                    class="checkbox__indeterminate-icon"
                    library="system"
                    name="indeterminate"
                  ></sl-icon>
                ` : ""}
          </span>

          <div part="label" class="checkbox__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${hasHelpText ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$009d7d74a34fb167$export$7f3be6aba957b8f2.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $fc719b2fd5802da3$export$e7c8528c268605e9),
    (0, $a389eb20a96d5584$export$d780863e08270d06)
];
$009d7d74a34fb167$export$7f3be6aba957b8f2.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)('input[type="checkbox"]')
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "input", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "title", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "checked", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "indeterminate", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b27873656deb6259$export$1a01ae0705bafd37)("checked")
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "defaultChecked", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "form", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "required", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "helpText", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "handleDisabledChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)([
        "checked",
        "indeterminate"
    ], {
        waitUntilFirstUpdate: true
    })
], $009d7d74a34fb167$export$7f3be6aba957b8f2.prototype, "handleStateChange", 1);


// src/components/checkbox/checkbox.ts
var $a3b4aa3c5081cb52$export$40f39952efc279e6 = (0, $009d7d74a34fb167$export$7f3be6aba957b8f2);
(0, $009d7d74a34fb167$export$7f3be6aba957b8f2).define("sl-checkbox");






parcelRequire("c69rD");










parcelRequire("jPx3Q");


// src/components/textarea/textarea.styles.ts

var $bea24a8748946e20$export$884e7f8ce9b7053a = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .textarea {
    display: grid;
    align-items: center;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
    cursor: text;
  }

  /* Standard textareas */
  .textarea--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .textarea--standard:hover:not(.textarea--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }
  .textarea--standard:hover:not(.textarea--disabled) .textarea__control {
    color: var(--sl-input-color-hover);
  }

  .textarea--standard.textarea--focused:not(.textarea--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    color: var(--sl-input-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .textarea--standard.textarea--focused:not(.textarea--disabled) .textarea__control {
    color: var(--sl-input-color-focus);
  }

  .textarea--standard.textarea--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .textarea__control,
  .textarea__size-adjuster {
    grid-area: 1 / 1 / 2 / 2;
  }

  .textarea__size-adjuster {
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
  }

  .textarea--standard.textarea--disabled .textarea__control {
    color: var(--sl-input-color-disabled);
  }

  .textarea--standard.textarea--disabled .textarea__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled textareas */
  .textarea--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .textarea--filled:hover:not(.textarea--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .textarea--filled.textarea--focused:not(.textarea--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .textarea--filled.textarea--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .textarea__control {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: 1.4;
    color: var(--sl-input-color);
    border: none;
    background: none;
    box-shadow: none;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .textarea__control::-webkit-search-decoration,
  .textarea__control::-webkit-search-cancel-button,
  .textarea__control::-webkit-search-results-button,
  .textarea__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .textarea__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .textarea__control:focus {
    outline: none;
  }

  /*
   * Size modifiers
   */

  .textarea--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
  }

  .textarea--small .textarea__control {
    padding: 0.5em var(--sl-input-spacing-small);
  }

  .textarea--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .textarea--medium .textarea__control {
    padding: 0.5em var(--sl-input-spacing-medium);
  }

  .textarea--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
  }

  .textarea--large .textarea__control {
    padding: 0.5em var(--sl-input-spacing-large);
  }

  /*
   * Resize types
   */

  .textarea--resize-none .textarea__control {
    resize: none;
  }

  .textarea--resize-vertical .textarea__control {
    resize: vertical;
  }

  .textarea--resize-auto .textarea__control {
    height: auto;
    resize: none;
    overflow-y: hidden;
  }
`;





var $c69rD = parcelRequire("c69rD");





var $jPx3Q = parcelRequire("jPx3Q");





var $b36489f8244a0f9c$export$93b8d6e5b0c01a7e = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $c69rD.FormControlController)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.value = "";
        this.size = "medium";
        this.filled = false;
        this.label = "";
        this.helpText = "";
        this.placeholder = "";
        this.rows = 4;
        this.resize = "vertical";
        this.disabled = false;
        this.readonly = false;
        this.form = "";
        this.required = false;
        this.spellcheck = true;
        this.defaultValue = "";
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver(()=>this.setTextareaHeight());
        this.updateComplete.then(()=>{
            this.setTextareaHeight();
            this.resizeObserver.observe(this.input);
        });
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        if (this.input) (_a = this.resizeObserver) == null || _a.unobserve(this.input);
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleChange() {
        this.value = this.input.value;
        this.setTextareaHeight();
        this.emit("sl-change");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleInput() {
        this.value = this.input.value;
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    setTextareaHeight() {
        if (this.resize === "auto") {
            this.sizeAdjuster.style.height = `${this.input.clientHeight}px`;
            this.input.style.height = "auto";
            this.input.style.height = `${this.input.scrollHeight}px`;
        } else this.input.style.height = "";
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleRowsChange() {
        this.setTextareaHeight();
    }
    async handleValueChange() {
        await this.updateComplete;
        this.formControlController.updateValidity();
        this.setTextareaHeight();
    }
    /** Sets focus on the textarea. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the textarea. */ blur() {
        this.input.blur();
    }
    /** Selects all the text in the textarea. */ select() {
        this.input.select();
    }
    /** Gets or sets the textarea's scroll position. */ scrollPosition(position) {
        if (position) {
            if (typeof position.top === "number") this.input.scrollTop = position.top;
            if (typeof position.left === "number") this.input.scrollLeft = position.left;
            return void 0;
        }
        return {
            top: this.input.scrollTop,
            left: this.input.scrollTop
        };
    }
    /** Sets the start and end positions of the text selection (0-based). */ setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
        this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    /** Replaces a range of text with a new string. */ setRangeText(replacement, start, end, selectMode = "preserve") {
        const selectionStart = start != null ? start : this.input.selectionStart;
        const selectionEnd = end != null ? end : this.input.selectionEnd;
        this.input.setRangeText(replacement, selectionStart, selectionEnd, selectMode);
        if (this.value !== this.input.value) {
            this.value = this.input.value;
            this.setTextareaHeight();
        }
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${hasLabel ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            textarea: true,
            "textarea--small": this.size === "small",
            "textarea--medium": this.size === "medium",
            "textarea--large": this.size === "large",
            "textarea--standard": !this.filled,
            "textarea--filled": this.filled,
            "textarea--disabled": this.disabled,
            "textarea--focused": this.hasFocus,
            "textarea--empty": !this.value,
            "textarea--resize-none": this.resize === "none",
            "textarea--resize-vertical": this.resize === "vertical",
            "textarea--resize-auto": this.resize === "auto"
        })}
          >
            <textarea
              part="textarea"
              id="input"
              class="textarea__control"
              title=${this.title}
              name=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.name)}
              .value=${(0, $cc5d598867de3edb$export$28cf49ad70f82d12)(this.value)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.placeholder)}
              rows=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.rows)}
              minlength=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.minlength)}
              maxlength=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.maxlength)}
              autocapitalize=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.autocapitalize)}
              autocorrect=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.spellcheck)}
              enterkeyhint=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.enterkeyhint)}
              inputmode=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            ></textarea>
            <!-- This "adjuster" exists to prevent layout shifting. https://github.com/shoelace-style/shoelace/issues/2180 -->
            <div part="textarea-adjuster" class="textarea__size-adjuster" ?hidden=${this.resize !== "auto"}></div>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$b36489f8244a0f9c$export$93b8d6e5b0c01a7e.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $fc719b2fd5802da3$export$e7c8528c268605e9),
    (0, $bea24a8748946e20$export$884e7f8ce9b7053a)
];
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".textarea__control")
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "input", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".textarea__size-adjuster")
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "sizeAdjuster", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "hasFocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "title", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "name", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "value", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "size", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "filled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "label", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "helpText", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "placeholder", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "rows", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "resize", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "readonly", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "form", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "required", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "minlength", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "maxlength", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "autocapitalize", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "autocorrect", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "autocomplete", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "autofocus", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "enterkeyhint", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        converter: {
            // Allow "true|false" attribute values but keep the property boolean
            fromAttribute: (value)=>!value || value === "false" ? false : true,
            toAttribute: (value)=>value ? "true" : "false"
        }
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "spellcheck", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "inputmode", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b27873656deb6259$export$1a01ae0705bafd37)()
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "defaultValue", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "handleDisabledChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("rows", {
        waitUntilFirstUpdate: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "handleRowsChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("value", {
        waitUntilFirstUpdate: true
    })
], $b36489f8244a0f9c$export$93b8d6e5b0c01a7e.prototype, "handleValueChange", 1);


// src/components/textarea/textarea.ts
var $cd9ded005899e121$export$c4dd1ba18c3111fc = (0, $b36489f8244a0f9c$export$93b8d6e5b0c01a7e);
(0, $b36489f8244a0f9c$export$93b8d6e5b0c01a7e).define("sl-textarea");






parcelRequire("c69rD");




parcelRequire("jPx3Q");


// src/components/details/details.styles.ts

var $8b7b9e0a5d988d77$export$e0460a263d3b7bef = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .details {
    border: solid 1px var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    background-color: var(--sl-color-neutral-0);
    overflow-anchor: none;
  }

  .details--disabled {
    opacity: 0.5;
  }

  .details__header {
    display: flex;
    align-items: center;
    border-radius: inherit;
    padding: var(--sl-spacing-medium);
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
  }

  .details__header::-webkit-details-marker {
    display: none;
  }

  .details__header:focus {
    outline: none;
  }

  .details__header:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: calc(1px + var(--sl-focus-ring-offset));
  }

  .details--disabled .details__header {
    cursor: not-allowed;
  }

  .details--disabled .details__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .details__summary {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .details__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
  }

  .details--open .details__summary-icon {
    rotate: 90deg;
  }

  .details--open.details--rtl .details__summary-icon {
    rotate: -90deg;
  }

  .details--open slot[name='expand-icon'],
  .details:not(.details--open) slot[name='collapse-icon'] {
    display: none;
  }

  .details__body {
    overflow: hidden;
  }

  .details__content {
    display: block;
    padding: var(--sl-spacing-medium);
  }
`;



var $jPx3Q = parcelRequire("jPx3Q");
// src/utilities/animation-registry.ts
var $5f2b86433aece85c$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $5f2b86433aece85c$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $5f2b86433aece85c$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $5f2b86433aece85c$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $5f2b86433aece85c$export$6e92ecdbe15fda0b(animationName, animation) {
    $5f2b86433aece85c$var$defaultAnimationRegistry.set(animationName, $5f2b86433aece85c$var$ensureAnimation(animation));
}
function $5f2b86433aece85c$export$ea45326d94a48a31(el, animationName, animation) {
    $5f2b86433aece85c$var$customAnimationRegistry.set(el, (0, $jPx3Q.__spreadProps)((0, $jPx3Q.__spreadValues)({}, $5f2b86433aece85c$var$customAnimationRegistry.get(el)), {
        [animationName]: $5f2b86433aece85c$var$ensureAnimation(animation)
    }));
}
function $5f2b86433aece85c$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $5f2b86433aece85c$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $5f2b86433aece85c$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $5f2b86433aece85c$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $5f2b86433aece85c$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $1fd801253c6f0585$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



var $jPx3Q = parcelRequire("jPx3Q");
// src/internal/animate.ts
function $10aa4c887a27439c$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $jPx3Q.__spreadProps)((0, $jPx3Q.__spreadValues)({}, options), {
            duration: $10aa4c887a27439c$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $10aa4c887a27439c$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $10aa4c887a27439c$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $10aa4c887a27439c$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            animation.cancel();
            requestAnimationFrame(resolve);
        });
    }));
}
function $10aa4c887a27439c$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $jPx3Q.__spreadProps)((0, $jPx3Q.__spreadValues)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}








var $jPx3Q = parcelRequire("jPx3Q");



var $f4735c164c7ecda5$export$ada524cc60438dd5 = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $a8a344465f70fe58$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.disabled = false;
    }
    firstUpdated() {
        this.body.style.height = this.open ? "auto" : "0";
        if (this.open) this.details.open = true;
        this.detailsObserver = new MutationObserver((changes)=>{
            for (const change of changes)if (change.type === "attributes" && change.attributeName === "open") {
                if (this.details.open) this.show();
                else this.hide();
            }
        });
        this.detailsObserver.observe(this.details, {
            attributes: true
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.detailsObserver) == null || _a.disconnect();
    }
    handleSummaryClick(event) {
        event.preventDefault();
        if (!this.disabled) {
            if (this.open) this.hide();
            else this.show();
            this.header.focus();
        }
    }
    handleSummaryKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (this.open) this.hide();
            else this.show();
        }
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            event.preventDefault();
            this.hide();
        }
        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            event.preventDefault();
            this.show();
        }
    }
    async handleOpenChange() {
        if (this.open) {
            this.details.open = true;
            const slShow = this.emit("sl-show", {
                cancelable: true
            });
            if (slShow.defaultPrevented) {
                this.open = false;
                this.details.open = false;
                return;
            }
            await (0, $10aa4c887a27439c$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "details.show", {
                dir: this.localize.dir()
            });
            await (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.body, (0, $10aa4c887a27439c$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.emit("sl-after-show");
        } else {
            const slHide = this.emit("sl-hide", {
                cancelable: true
            });
            if (slHide.defaultPrevented) {
                this.details.open = true;
                this.open = true;
                return;
            }
            await (0, $10aa4c887a27439c$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "details.hide", {
                dir: this.localize.dir()
            });
            await (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.body, (0, $10aa4c887a27439c$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.details.open = false;
            this.emit("sl-after-hide");
        }
    }
    /** Shows the details. */ async show() {
        if (this.open || this.disabled) return void 0;
        this.open = true;
        return (0, $1fd801253c6f0585$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the details */ async hide() {
        if (!this.open || this.disabled) return void 0;
        this.open = false;
        return (0, $1fd801253c6f0585$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <details
        part="base"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            details: true,
            "details--open": this.open,
            "details--disabled": this.disabled,
            "details--rtl": isRtl
        })}
      >
        <summary
          part="header"
          id="header"
          class="details__header"
          role="button"
          aria-expanded=${this.open ? "true" : "false"}
          aria-controls="content"
          aria-disabled=${this.disabled ? "true" : "false"}
          tabindex=${this.disabled ? "-1" : "0"}
          @click=${this.handleSummaryClick}
          @keydown=${this.handleSummaryKeyDown}
        >
          <slot name="summary" part="summary" class="details__summary">${this.summary}</slot>

          <span part="summary-icon" class="details__summary-icon">
            <slot name="expand-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
            <slot name="collapse-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
          </span>
        </summary>

        <div class="details__body" role="region" aria-labelledby="header">
          <slot part="content" id="content" class="details__content"></slot>
        </div>
      </details>
    `;
    }
};
$f4735c164c7ecda5$export$ada524cc60438dd5.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $8b7b9e0a5d988d77$export$e0460a263d3b7bef)
];
$f4735c164c7ecda5$export$ada524cc60438dd5.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".details")
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "details", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".details__header")
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "header", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".details__body")
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "body", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".details__expand-icon-slot")
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "expandIconSlot", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "open", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "summary", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "disabled", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $f4735c164c7ecda5$export$ada524cc60438dd5.prototype, "handleOpenChange", 1);
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("details.show", {
    keyframes: [
        {
            height: "0",
            opacity: "0"
        },
        {
            height: "auto",
            opacity: "1"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("details.hide", {
    keyframes: [
        {
            height: "auto",
            opacity: "1"
        },
        {
            height: "0",
            opacity: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});


// src/components/details/details.ts
var $0790342ba03f9b5f$export$991e1c3cf581681b = (0, $f4735c164c7ecda5$export$ada524cc60438dd5);
(0, $f4735c164c7ecda5$export$ada524cc60438dd5).define("sl-details");


















parcelRequire("jPx3Q");



var $jPx3Q = parcelRequire("jPx3Q");
// src/internal/active-elements.ts
function* $abd6e7b0da80f9e0$export$f1011118e6e82d25(activeElement = document.activeElement) {
    if (activeElement === null || activeElement === void 0) return;
    yield activeElement;
    if ("shadowRoot" in activeElement && activeElement.shadowRoot && activeElement.shadowRoot.mode !== "closed") yield* (0, $jPx3Q.__yieldStar)($abd6e7b0da80f9e0$export$f1011118e6e82d25(activeElement.shadowRoot.activeElement));
}
function $abd6e7b0da80f9e0$export$b582f6fea197d721() {
    return [
        ...$abd6e7b0da80f9e0$export$f1011118e6e82d25()
    ].pop();
}
// src/internal/tabbable.ts
var $abd6e7b0da80f9e0$var$computedStyleMap = /* @__PURE__ */ new WeakMap();
function $abd6e7b0da80f9e0$var$getCachedComputedStyle(el) {
    let computedStyle = $abd6e7b0da80f9e0$var$computedStyleMap.get(el);
    if (!computedStyle) {
        computedStyle = window.getComputedStyle(el, null);
        $abd6e7b0da80f9e0$var$computedStyleMap.set(el, computedStyle);
    }
    return computedStyle;
}
function $abd6e7b0da80f9e0$var$isVisible(el) {
    if (typeof el.checkVisibility === "function") return el.checkVisibility({
        checkOpacity: false,
        checkVisibilityCSS: true
    });
    const computedStyle = $abd6e7b0da80f9e0$var$getCachedComputedStyle(el);
    return computedStyle.visibility !== "hidden" && computedStyle.display !== "none";
}
function $abd6e7b0da80f9e0$var$isOverflowingAndTabbable(el) {
    const computedStyle = $abd6e7b0da80f9e0$var$getCachedComputedStyle(el);
    const { overflowY: overflowY, overflowX: overflowX } = computedStyle;
    if (overflowY === "scroll" || overflowX === "scroll") return true;
    if (overflowY !== "auto" || overflowX !== "auto") return false;
    const isOverflowingY = el.scrollHeight > el.clientHeight;
    if (isOverflowingY && overflowY === "auto") return true;
    const isOverflowingX = el.scrollWidth > el.clientWidth;
    if (isOverflowingX && overflowX === "auto") return true;
    return false;
}
function $abd6e7b0da80f9e0$var$isTabbable(el) {
    const tag = el.tagName.toLowerCase();
    const tabindex = Number(el.getAttribute("tabindex"));
    const hasTabindex = el.hasAttribute("tabindex");
    if (hasTabindex && (isNaN(tabindex) || tabindex <= -1)) return false;
    if (el.hasAttribute("disabled")) return false;
    if (el.closest("[inert]")) return false;
    if (tag === "input" && el.getAttribute("type") === "radio") {
        const rootNode = el.getRootNode();
        const findRadios = `input[type='radio'][name="${el.getAttribute("name")}"]`;
        const firstChecked = rootNode.querySelector(`${findRadios}:checked`);
        if (firstChecked) return firstChecked === el;
        const firstRadio = rootNode.querySelector(findRadios);
        return firstRadio === el;
    }
    if (!$abd6e7b0da80f9e0$var$isVisible(el)) return false;
    if ((tag === "audio" || tag === "video") && el.hasAttribute("controls")) return true;
    if (el.hasAttribute("tabindex")) return true;
    if (el.hasAttribute("contenteditable") && el.getAttribute("contenteditable") !== "false") return true;
    const isNativelyTabbable = [
        "button",
        "input",
        "select",
        "textarea",
        "a",
        "audio",
        "video",
        "summary",
        "iframe"
    ].includes(tag);
    if (isNativelyTabbable) return true;
    return $abd6e7b0da80f9e0$var$isOverflowingAndTabbable(el);
}
function $abd6e7b0da80f9e0$export$16b821ece3e89e24(root) {
    var _a, _b;
    const tabbableElements = $abd6e7b0da80f9e0$export$59a770a0e59b0dd2(root);
    const start = (_a = tabbableElements[0]) != null ? _a : null;
    const end = (_b = tabbableElements[tabbableElements.length - 1]) != null ? _b : null;
    return {
        start: start,
        end: end
    };
}
function $abd6e7b0da80f9e0$var$getSlottedChildrenOutsideRootElement(slotElement, root) {
    var _a;
    return ((_a = slotElement.getRootNode({
        composed: true
    })) == null ? void 0 : _a.host) !== root;
}
function $abd6e7b0da80f9e0$export$59a770a0e59b0dd2(root) {
    const walkedEls = /* @__PURE__ */ new WeakMap();
    const tabbableElements = [];
    function walk(el) {
        if (el instanceof Element) {
            if (el.hasAttribute("inert") || el.closest("[inert]")) return;
            if (walkedEls.has(el)) return;
            walkedEls.set(el, true);
            if (!tabbableElements.includes(el) && $abd6e7b0da80f9e0$var$isTabbable(el)) tabbableElements.push(el);
            if (el instanceof HTMLSlotElement && $abd6e7b0da80f9e0$var$getSlottedChildrenOutsideRootElement(el, root)) el.assignedElements({
                flatten: true
            }).forEach((assignedEl)=>{
                walk(assignedEl);
            });
            if (el.shadowRoot !== null && el.shadowRoot.mode === "open") walk(el.shadowRoot);
        }
        for (const e of el.children)walk(e);
    }
    walk(root);
    return tabbableElements.sort((a, b)=>{
        const aTabindex = Number(a.getAttribute("tabindex")) || 0;
        const bTabindex = Number(b.getAttribute("tabindex")) || 0;
        return bTabindex - aTabindex;
    });
}


// src/internal/modal.ts
var $4918330233a73cec$var$activeModals = [];
var $4918330233a73cec$export$2b77a92f1a5ad772 = class {
    constructor(element){
        this.tabDirection = "forward";
        this.handleFocusIn = ()=>{
            if (!this.isActive()) return;
            this.checkFocus();
        };
        this.handleKeyDown = (event)=>{
            var _a;
            if (event.key !== "Tab" || this.isExternalActivated) return;
            if (!this.isActive()) return;
            const currentActiveElement = (0, $abd6e7b0da80f9e0$export$b582f6fea197d721)();
            this.previousFocus = currentActiveElement;
            if (this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus)) return;
            if (event.shiftKey) this.tabDirection = "backward";
            else this.tabDirection = "forward";
            const tabbableElements = (0, $abd6e7b0da80f9e0$export$59a770a0e59b0dd2)(this.element);
            let currentFocusIndex = tabbableElements.findIndex((el)=>el === currentActiveElement);
            this.previousFocus = this.currentFocus;
            const addition = this.tabDirection === "forward" ? 1 : -1;
            while(true){
                if (currentFocusIndex + addition >= tabbableElements.length) currentFocusIndex = 0;
                else if (currentFocusIndex + addition < 0) currentFocusIndex = tabbableElements.length - 1;
                else currentFocusIndex += addition;
                this.previousFocus = this.currentFocus;
                const nextFocus = /** @type {HTMLElement} */ tabbableElements[currentFocusIndex];
                if (this.tabDirection === "backward") {
                    if (this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus)) return;
                }
                if (nextFocus && this.possiblyHasTabbableChildren(nextFocus)) return;
                event.preventDefault();
                this.currentFocus = nextFocus;
                (_a = this.currentFocus) == null || _a.focus({
                    preventScroll: false
                });
                const allActiveElements = [
                    ...(0, $abd6e7b0da80f9e0$export$f1011118e6e82d25)()
                ];
                if (allActiveElements.includes(this.currentFocus) || !allActiveElements.includes(this.previousFocus)) break;
            }
            setTimeout(()=>this.checkFocus());
        };
        this.handleKeyUp = ()=>{
            this.tabDirection = "forward";
        };
        this.element = element;
        this.elementsWithTabbableControls = [
            "iframe"
        ];
    }
    /** Activates focus trapping. */ activate() {
        $4918330233a73cec$var$activeModals.push(this.element);
        document.addEventListener("focusin", this.handleFocusIn);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("keyup", this.handleKeyUp);
    }
    /** Deactivates focus trapping. */ deactivate() {
        $4918330233a73cec$var$activeModals = $4918330233a73cec$var$activeModals.filter((modal)=>modal !== this.element);
        this.currentFocus = null;
        document.removeEventListener("focusin", this.handleFocusIn);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("keyup", this.handleKeyUp);
    }
    /** Determines if this modal element is currently active or not. */ isActive() {
        return $4918330233a73cec$var$activeModals[$4918330233a73cec$var$activeModals.length - 1] === this.element;
    }
    /** Activates external modal behavior and temporarily disables focus trapping. */ activateExternal() {
        this.isExternalActivated = true;
    }
    /** Deactivates external modal behavior and re-enables focus trapping. */ deactivateExternal() {
        this.isExternalActivated = false;
    }
    checkFocus() {
        if (this.isActive() && !this.isExternalActivated) {
            const tabbableElements = (0, $abd6e7b0da80f9e0$export$59a770a0e59b0dd2)(this.element);
            if (!this.element.matches(":focus-within")) {
                const start = tabbableElements[0];
                const end = tabbableElements[tabbableElements.length - 1];
                const target = this.tabDirection === "forward" ? start : end;
                if (typeof (target == null ? void 0 : target.focus) === "function") {
                    this.currentFocus = target;
                    target.focus({
                        preventScroll: false
                    });
                }
            }
        }
    }
    possiblyHasTabbableChildren(element) {
        return this.elementsWithTabbableControls.includes(element.tagName.toLowerCase()) || element.hasAttribute("controls");
    }
};


// src/internal/offset.ts
function $96c82a24ec034365$var$getOffset(element, parent) {
    return {
        top: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        left: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left)
    };
}
// src/internal/scroll.ts
var $96c82a24ec034365$var$locks = /* @__PURE__ */ new Set();
function $96c82a24ec034365$var$getScrollbarWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
function $96c82a24ec034365$var$getExistingBodyPadding() {
    const padding = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
    if (isNaN(padding) || !padding) return 0;
    return padding;
}
function $96c82a24ec034365$export$5f4bd35c67f2403d(lockingEl) {
    $96c82a24ec034365$var$locks.add(lockingEl);
    if (!document.documentElement.classList.contains("sl-scroll-lock")) {
        const scrollbarWidth = $96c82a24ec034365$var$getScrollbarWidth() + $96c82a24ec034365$var$getExistingBodyPadding();
        let scrollbarGutterProperty = getComputedStyle(document.documentElement).scrollbarGutter;
        if (!scrollbarGutterProperty || scrollbarGutterProperty === "auto") scrollbarGutterProperty = "stable";
        if (scrollbarWidth < 2) scrollbarGutterProperty = "";
        document.documentElement.style.setProperty("--sl-scroll-lock-gutter", scrollbarGutterProperty);
        document.documentElement.classList.add("sl-scroll-lock");
        document.documentElement.style.setProperty("--sl-scroll-lock-size", `${scrollbarWidth}px`);
    }
}
function $96c82a24ec034365$export$7475b4759872c980(lockingEl) {
    $96c82a24ec034365$var$locks.delete(lockingEl);
    if ($96c82a24ec034365$var$locks.size === 0) {
        document.documentElement.classList.remove("sl-scroll-lock");
        document.documentElement.style.removeProperty("--sl-scroll-lock-size");
    }
}
function $96c82a24ec034365$export$53a0910f038337bd(element, container, direction = "vertical", behavior = "smooth") {
    const offset = $96c82a24ec034365$var$getOffset(element, container);
    const offsetTop = offset.top + container.scrollTop;
    const offsetLeft = offset.left + container.scrollLeft;
    const minX = container.scrollLeft;
    const maxX = container.scrollLeft + container.offsetWidth;
    const minY = container.scrollTop;
    const maxY = container.scrollTop + container.offsetHeight;
    if (direction === "horizontal" || direction === "both") {
        if (offsetLeft < minX) container.scrollTo({
            left: offsetLeft,
            behavior: behavior
        });
        else if (offsetLeft + element.clientWidth > maxX) container.scrollTo({
            left: offsetLeft - container.offsetWidth + element.clientWidth,
            behavior: behavior
        });
    }
    if (direction === "vertical" || direction === "both") {
        if (offsetTop < minY) container.scrollTo({
            top: offsetTop,
            behavior: behavior
        });
        else if (offsetTop + element.clientHeight > maxY) container.scrollTo({
            top: offsetTop - container.offsetHeight + element.clientHeight,
            behavior: behavior
        });
    }
}


// src/components/dialog/dialog.styles.ts

var $2357f3db92fd993b$export$b752f4490c3ab6b1 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`;


// src/internal/closeActiveElement.ts
var $b0899e70e9b00ed3$export$7868286b01c1cec2 = (elm)=>{
    var _a;
    const { activeElement: activeElement } = document;
    if (activeElement && elm.contains(activeElement)) (_a = document.activeElement) == null || _a.blur();
};












var $jPx3Q = parcelRequire("jPx3Q");




var $ca2cee48fa62dddd$export$2a86abe166e5892d = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $134116549af3fc49$export$34f6a5ffaa663541)(this, "footer");
        this.localize = new (0, $a8a344465f70fe58$export$b1a2fed5bb41b893)(this);
        this.modal = new (0, $4918330233a73cec$export$2b77a92f1a5ad772)(this);
        this.open = false;
        this.label = "";
        this.noHeader = false;
        this.handleDocumentKeyDown = (event)=>{
            if (event.key === "Escape" && this.modal.isActive() && this.open) {
                event.stopPropagation();
                this.requestClose("keyboard");
            }
        };
    }
    firstUpdated() {
        this.dialog.hidden = !this.open;
        if (this.open) {
            this.addOpenListeners();
            this.modal.activate();
            (0, $96c82a24ec034365$export$5f4bd35c67f2403d)(this);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.modal.deactivate();
        (0, $96c82a24ec034365$export$7475b4759872c980)(this);
        this.removeOpenListeners();
    }
    requestClose(source) {
        const slRequestClose = this.emit("sl-request-close", {
            cancelable: true,
            detail: {
                source: source
            }
        });
        if (slRequestClose.defaultPrevented) {
            const animation = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "dialog.denyClose", {
                dir: this.localize.dir()
            });
            (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.panel, animation.keyframes, animation.options);
            return;
        }
        this.hide();
    }
    addOpenListeners() {
        var _a;
        if ("CloseWatcher" in window) {
            (_a = this.closeWatcher) == null || _a.destroy();
            this.closeWatcher = new CloseWatcher();
            this.closeWatcher.onclose = ()=>this.requestClose("keyboard");
        } else document.addEventListener("keydown", this.handleDocumentKeyDown);
    }
    removeOpenListeners() {
        var _a;
        (_a = this.closeWatcher) == null || _a.destroy();
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            this.addOpenListeners();
            this.originalTrigger = document.activeElement;
            this.modal.activate();
            (0, $96c82a24ec034365$export$5f4bd35c67f2403d)(this);
            const autoFocusTarget = this.querySelector("[autofocus]");
            if (autoFocusTarget) autoFocusTarget.removeAttribute("autofocus");
            await Promise.all([
                (0, $10aa4c887a27439c$export$ad12f740028ccbea)(this.dialog),
                (0, $10aa4c887a27439c$export$ad12f740028ccbea)(this.overlay)
            ]);
            this.dialog.hidden = false;
            requestAnimationFrame(()=>{
                const slInitialFocus = this.emit("sl-initial-focus", {
                    cancelable: true
                });
                if (!slInitialFocus.defaultPrevented) {
                    if (autoFocusTarget) autoFocusTarget.focus({
                        preventScroll: true
                    });
                    else this.panel.focus({
                        preventScroll: true
                    });
                }
                if (autoFocusTarget) autoFocusTarget.setAttribute("autofocus", "");
            });
            const panelAnimation = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "dialog.show", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "dialog.overlay.show", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options),
                (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
            ]);
            this.emit("sl-after-show");
        } else {
            (0, $b0899e70e9b00ed3$export$7868286b01c1cec2)(this);
            this.emit("sl-hide");
            this.removeOpenListeners();
            this.modal.deactivate();
            await Promise.all([
                (0, $10aa4c887a27439c$export$ad12f740028ccbea)(this.dialog),
                (0, $10aa4c887a27439c$export$ad12f740028ccbea)(this.overlay)
            ]);
            const panelAnimation = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "dialog.hide", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $5f2b86433aece85c$export$b1aed5dec0c2d368)(this, "dialog.overlay.hide", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options).then(()=>{
                    this.overlay.hidden = true;
                }),
                (0, $10aa4c887a27439c$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options).then(()=>{
                    this.panel.hidden = true;
                })
            ]);
            this.dialog.hidden = true;
            this.overlay.hidden = false;
            this.panel.hidden = false;
            (0, $96c82a24ec034365$export$7475b4759872c980)(this);
            const trigger = this.originalTrigger;
            if (typeof (trigger == null ? void 0 : trigger.focus) === "function") setTimeout(()=>trigger.focus());
            this.emit("sl-after-hide");
        }
    }
    /** Shows the dialog. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $1fd801253c6f0585$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the dialog */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $1fd801253c6f0585$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            dialog: true,
            "dialog--open": this.open,
            "dialog--has-footer": this.hasSlotController.test("footer")
        })}
      >
        <div part="overlay" class="dialog__overlay" @click=${()=>this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(this.noHeader ? this.label : void 0)}
          aria-labelledby=${(0, $597a805efc9ad164$export$f68dd208b5df064d)(!this.noHeader ? "title" : void 0)}
          tabindex="-1"
        >
          ${!this.noHeader ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : String.fromCharCode(65279)} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${()=>this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              ` : ""}
          ${""}
          <div part="body" class="dialog__body" tabindex="-1"><slot></slot></div>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
    }
};
$ca2cee48fa62dddd$export$2a86abe166e5892d.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $2357f3db92fd993b$export$b752f4490c3ab6b1)
];
$ca2cee48fa62dddd$export$2a86abe166e5892d.dependencies = {
    "sl-icon-button": (0, $7c81203c9668765b$export$302c9d29315a4659)
};
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".dialog")
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "dialog", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".dialog__panel")
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "panel", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".dialog__overlay")
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "overlay", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "open", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        reflect: true
    })
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "label", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        attribute: "no-header",
        type: Boolean,
        reflect: true
    })
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "noHeader", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $ca2cee48fa62dddd$export$2a86abe166e5892d.prototype, "handleOpenChange", 1);
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("dialog.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("dialog.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("dialog.denyClose", {
    keyframes: [
        {
            scale: 1
        },
        {
            scale: 1.02
        },
        {
            scale: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("dialog.overlay.show", {
    keyframes: [
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $5f2b86433aece85c$export$6e92ecdbe15fda0b)("dialog.overlay.hide", {
    keyframes: [
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ],
    options: {
        duration: 250
    }
});


// src/components/dialog/dialog.ts
var $6c4705e55b367a76$export$585117cab3e12d3 = (0, $ca2cee48fa62dddd$export$2a86abe166e5892d);
(0, $ca2cee48fa62dddd$export$2a86abe166e5892d).define("sl-dialog");

























parcelRequire("jPx3Q");


// src/internal/math.ts
function $17aee557d88adde4$export$7d15b64cf5a3a4c4(value, min, max) {
    const noNegativeZero = (n)=>Object.is(n, -0) ? 0 : n;
    if (value < min) return noNegativeZero(min);
    if (value > max) return noNegativeZero(max);
    return noNegativeZero(value);
}


// src/components/carousel/autoplay-controller.ts
var $395d1fc890881dea$export$a9a0b55bc0093be5 = class {
    constructor(host, tickCallback){
        this.timerId = 0;
        this.activeInteractions = 0;
        this.paused = false;
        this.stopped = true;
        this.pause = ()=>{
            if (!this.activeInteractions++) {
                this.paused = true;
                this.host.requestUpdate();
            }
        };
        this.resume = ()=>{
            if (!--this.activeInteractions) {
                this.paused = false;
                this.host.requestUpdate();
            }
        };
        host.addController(this);
        this.host = host;
        this.tickCallback = tickCallback;
    }
    hostConnected() {
        this.host.addEventListener("mouseenter", this.pause);
        this.host.addEventListener("mouseleave", this.resume);
        this.host.addEventListener("focusin", this.pause);
        this.host.addEventListener("focusout", this.resume);
        this.host.addEventListener("touchstart", this.pause, {
            passive: true
        });
        this.host.addEventListener("touchend", this.resume);
    }
    hostDisconnected() {
        this.stop();
        this.host.removeEventListener("mouseenter", this.pause);
        this.host.removeEventListener("mouseleave", this.resume);
        this.host.removeEventListener("focusin", this.pause);
        this.host.removeEventListener("focusout", this.resume);
        this.host.removeEventListener("touchstart", this.pause);
        this.host.removeEventListener("touchend", this.resume);
    }
    start(interval) {
        this.stop();
        this.stopped = false;
        this.timerId = window.setInterval(()=>{
            if (!this.paused) this.tickCallback();
        }, interval);
    }
    stop() {
        clearInterval(this.timerId);
        this.stopped = true;
        this.host.requestUpdate();
    }
};


// src/components/carousel/carousel.styles.ts

var $f93eeee79030574b$export$53f9b56b2cc2a838 = (0, $8d6d220e4f43fd73$export$dbf350e5966cf602)`
  :host {
    --slide-gap: var(--sl-spacing-medium, 1rem);
    --aspect-ratio: 16 / 9;
    --scroll-hint: 0px;

    display: flex;
  }

  .carousel {
    display: grid;
    grid-template-columns: min-content 1fr min-content;
    grid-template-rows: 1fr min-content;
    grid-template-areas:
      '. slides .'
      '. pagination .';
    gap: var(--sl-spacing-medium);
    align-items: center;
    min-height: 100%;
    min-width: 100%;
    position: relative;
  }

  .carousel__pagination {
    grid-area: pagination;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--sl-spacing-small);
  }

  .carousel__slides {
    grid-area: slides;

    display: grid;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-items: center;
    overflow: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
    aspect-ratio: calc(var(--aspect-ratio) * var(--slides-per-page));
    border-radius: var(--sl-border-radius-small);

    --slide-size: calc((100% - (var(--slides-per-page) - 1) * var(--slide-gap)) / var(--slides-per-page));
  }

  @media (prefers-reduced-motion) {
    :where(.carousel__slides) {
      scroll-behavior: auto;
    }
  }

  .carousel__slides--horizontal {
    grid-auto-flow: column;
    grid-auto-columns: var(--slide-size);
    grid-auto-rows: 100%;
    column-gap: var(--slide-gap);
    scroll-snap-type: x mandatory;
    scroll-padding-inline: var(--scroll-hint);
    padding-inline: var(--scroll-hint);
    overflow-y: hidden;
  }

  .carousel__slides--vertical {
    grid-auto-flow: row;
    grid-auto-columns: 100%;
    grid-auto-rows: var(--slide-size);
    row-gap: var(--slide-gap);
    scroll-snap-type: y mandatory;
    scroll-padding-block: var(--scroll-hint);
    padding-block: var(--scroll-hint);
    overflow-x: hidden;
  }

  .carousel__slides--dragging {
  }

  :host([vertical]) ::slotted(sl-carousel-item) {
    height: 100%;
  }

  .carousel__slides::-webkit-scrollbar {
    display: none;
  }

  .carousel__navigation {
    grid-area: navigation;
    display: contents;
    font-size: var(--sl-font-size-x-large);
  }

  .carousel__navigation-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-small);
    font-size: inherit;
    color: var(--sl-color-neutral-600);
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-medium) color;
    appearance: none;
  }

  .carousel__navigation-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .carousel__navigation-button--disabled::part(base) {
    pointer-events: none;
  }

  .carousel__navigation-button--previous {
    grid-column: 1;
    grid-row: 1;
  }

  .carousel__navigation-button--next {
    grid-column: 3;
    grid-row: 1;
  }

  .carousel__pagination-item {
    display: block;
    cursor: pointer;
    background: none;
    border: 0;
    border-radius: var(--sl-border-radius-circle);
    width: var(--sl-spacing-small);
    height: var(--sl-spacing-small);
    background-color: var(--sl-color-neutral-300);
    padding: 0;
    margin: 0;
  }

  .carousel__pagination-item--active {
    background-color: var(--sl-color-neutral-700);
    transform: scale(1.2);
  }

  /* Focus styles */
  .carousel__slides:focus-visible,
  .carousel__navigation-button:focus-visible,
  .carousel__pagination-item:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }
`;










var $jPx3Q = parcelRequire("jPx3Q");



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $5160fddeae65a964$export$871de8747c9eaa88(o, f) {
    if (void 0 !== o) {
        let i = 0;
        for (const t of o)yield f(t, i++);
    }
}




/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $c6a3155bf5999e32$export$d02631cccf789723(o1, t, e = 1) {
    const i = void 0 === t ? 0 : o1;
    t ??= o1;
    for(let o = i; e > 0 ? o < t : t < o; o += e)yield o;
}




var $c834915fe9b039f4$export$f07c6192812bdc3c = class extends (0, $2787ba9f20b771ed$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.loop = false;
        this.navigation = false;
        this.pagination = false;
        this.autoplay = false;
        this.autoplayInterval = 3e3;
        this.slidesPerPage = 1;
        this.slidesPerMove = 1;
        this.orientation = "horizontal";
        this.mouseDragging = false;
        this.activeSlide = 0;
        this.scrolling = false;
        this.dragging = false;
        this.autoplayController = new (0, $395d1fc890881dea$export$a9a0b55bc0093be5)(this, ()=>this.next());
        this.dragStartPosition = [
            -1,
            -1
        ];
        this.localize = new (0, $a8a344465f70fe58$export$b1a2fed5bb41b893)(this);
        this.pendingSlideChange = false;
        this.handleMouseDrag = (event)=>{
            if (!this.dragging) {
                this.scrollContainer.style.setProperty("scroll-snap-type", "none");
                this.dragging = true;
                this.dragStartPosition = [
                    event.clientX,
                    event.clientY
                ];
            }
            this.scrollContainer.scrollBy({
                left: -event.movementX,
                top: -event.movementY,
                behavior: "instant"
            });
        };
        this.handleMouseDragEnd = ()=>{
            const scrollContainer = this.scrollContainer;
            document.removeEventListener("pointermove", this.handleMouseDrag, {
                capture: true
            });
            const startLeft = scrollContainer.scrollLeft;
            const startTop = scrollContainer.scrollTop;
            scrollContainer.style.removeProperty("scroll-snap-type");
            scrollContainer.style.setProperty("overflow", "hidden");
            const finalLeft = scrollContainer.scrollLeft;
            const finalTop = scrollContainer.scrollTop;
            scrollContainer.style.removeProperty("overflow");
            scrollContainer.style.setProperty("scroll-snap-type", "none");
            scrollContainer.scrollTo({
                left: startLeft,
                top: startTop,
                behavior: "instant"
            });
            requestAnimationFrame(async ()=>{
                if (startLeft !== finalLeft || startTop !== finalTop) {
                    scrollContainer.scrollTo({
                        left: finalLeft,
                        top: finalTop,
                        behavior: (0, $10aa4c887a27439c$export$ff7706047246b98b)() ? "auto" : "smooth"
                    });
                    await (0, $1fd801253c6f0585$export$6608ab6fe9313967)(scrollContainer, "scrollend");
                }
                scrollContainer.style.removeProperty("scroll-snap-type");
                this.dragging = false;
                this.dragStartPosition = [
                    -1,
                    -1
                ];
                this.handleScrollEnd();
            });
        };
        this.handleSlotChange = (mutations)=>{
            const needsInitialization = mutations.some((mutation)=>[
                    ...mutation.addedNodes,
                    ...mutation.removedNodes
                ].some((el)=>this.isCarouselItem(el) && !el.hasAttribute("data-clone")));
            if (needsInitialization) this.initializeSlides();
            this.requestUpdate();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "region");
        this.setAttribute("aria-label", this.localize.term("carousel"));
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.mutationObserver) == null || _a.disconnect();
    }
    firstUpdated() {
        this.initializeSlides();
        this.mutationObserver = new MutationObserver(this.handleSlotChange);
        this.mutationObserver.observe(this, {
            childList: true,
            subtree: true
        });
    }
    willUpdate(changedProperties) {
        if (changedProperties.has("slidesPerMove") || changedProperties.has("slidesPerPage")) this.slidesPerMove = Math.min(this.slidesPerMove, this.slidesPerPage);
    }
    getPageCount() {
        const slidesCount = this.getSlides().length;
        const { slidesPerPage: slidesPerPage, slidesPerMove: slidesPerMove, loop: loop } = this;
        const pages = loop ? slidesCount / slidesPerMove : (slidesCount - slidesPerPage) / slidesPerMove + 1;
        return Math.ceil(pages);
    }
    getCurrentPage() {
        return Math.ceil(this.activeSlide / this.slidesPerMove);
    }
    canScrollNext() {
        return this.loop || this.getCurrentPage() < this.getPageCount() - 1;
    }
    canScrollPrev() {
        return this.loop || this.getCurrentPage() > 0;
    }
    /** @internal Gets all carousel items. */ getSlides({ excludeClones: excludeClones = true } = {}) {
        return [
            ...this.children
        ].filter((el)=>this.isCarouselItem(el) && (!excludeClones || !el.hasAttribute("data-clone")));
    }
    handleClick(event) {
        if (this.dragging && this.dragStartPosition[0] > 0 && this.dragStartPosition[1] > 0) {
            const deltaX = Math.abs(this.dragStartPosition[0] - event.clientX);
            const deltaY = Math.abs(this.dragStartPosition[1] - event.clientY);
            const delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            if (delta >= 10) event.preventDefault();
        }
    }
    handleKeyDown(event) {
        if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(event.key)) {
            const target = event.target;
            const isRtl = this.localize.dir() === "rtl";
            const isFocusInPagination = target.closest('[part~="pagination-item"]') !== null;
            const isNext = event.key === "ArrowDown" || !isRtl && event.key === "ArrowRight" || isRtl && event.key === "ArrowLeft";
            const isPrevious = event.key === "ArrowUp" || !isRtl && event.key === "ArrowLeft" || isRtl && event.key === "ArrowRight";
            event.preventDefault();
            if (isPrevious) this.previous();
            if (isNext) this.next();
            if (event.key === "Home") this.goToSlide(0);
            if (event.key === "End") this.goToSlide(this.getSlides().length - 1);
            if (isFocusInPagination) this.updateComplete.then(()=>{
                var _a;
                const activePaginationItem = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('[part~="pagination-item--active"]');
                if (activePaginationItem) activePaginationItem.focus();
            });
        }
    }
    handleMouseDragStart(event) {
        const canDrag = this.mouseDragging && event.button === 0;
        if (canDrag) {
            event.preventDefault();
            document.addEventListener("pointermove", this.handleMouseDrag, {
                capture: true,
                passive: true
            });
            document.addEventListener("pointerup", this.handleMouseDragEnd, {
                capture: true,
                once: true
            });
        }
    }
    handleScroll() {
        this.scrolling = true;
        if (!this.pendingSlideChange) this.synchronizeSlides();
    }
    /** @internal Synchronizes the slides with the IntersectionObserver API. */ synchronizeSlides() {
        const io = new IntersectionObserver((entries)=>{
            io.disconnect();
            for (const entry of entries){
                const slide = entry.target;
                slide.toggleAttribute("inert", !entry.isIntersecting);
                slide.classList.toggle("--in-view", entry.isIntersecting);
                slide.setAttribute("aria-hidden", entry.isIntersecting ? "false" : "true");
            }
            const firstIntersecting = entries.find((entry)=>entry.isIntersecting);
            if (!firstIntersecting) return;
            const slidesWithClones = this.getSlides({
                excludeClones: false
            });
            const slidesCount = this.getSlides().length;
            const slideIndex = slidesWithClones.indexOf(firstIntersecting.target);
            const normalizedIndex = this.loop ? slideIndex - this.slidesPerPage : slideIndex;
            this.activeSlide = (Math.ceil(normalizedIndex / this.slidesPerMove) * this.slidesPerMove + slidesCount) % slidesCount;
            if (!this.scrolling) {
                if (this.loop && firstIntersecting.target.hasAttribute("data-clone")) {
                    const clonePosition = Number(firstIntersecting.target.getAttribute("data-clone"));
                    this.goToSlide(clonePosition, "instant");
                }
            }
        }, {
            root: this.scrollContainer,
            threshold: 0.6
        });
        this.getSlides({
            excludeClones: false
        }).forEach((slide)=>{
            io.observe(slide);
        });
    }
    handleScrollEnd() {
        if (!this.scrolling || this.dragging) return;
        this.scrolling = false;
        this.pendingSlideChange = false;
        this.synchronizeSlides();
    }
    isCarouselItem(node) {
        return node instanceof Element && node.tagName.toLowerCase() === "sl-carousel-item";
    }
    initializeSlides() {
        this.getSlides({
            excludeClones: false
        }).forEach((slide, index)=>{
            slide.classList.remove("--in-view");
            slide.classList.remove("--is-active");
            slide.setAttribute("role", "group");
            slide.setAttribute("aria-label", this.localize.term("slideNum", index + 1));
            if (this.pagination) {
                slide.setAttribute("id", `slide-${index + 1}`);
                slide.setAttribute("role", "tabpanel");
                slide.removeAttribute("aria-label");
                slide.setAttribute("aria-labelledby", `tab-${index + 1}`);
            }
            if (slide.hasAttribute("data-clone")) slide.remove();
        });
        this.updateSlidesSnap();
        if (this.loop) this.createClones();
        this.goToSlide(this.activeSlide, "auto");
        this.synchronizeSlides();
    }
    createClones() {
        const slides = this.getSlides();
        const slidesPerPage = this.slidesPerPage;
        const lastSlides = slides.slice(-slidesPerPage);
        const firstSlides = slides.slice(0, slidesPerPage);
        lastSlides.reverse().forEach((slide, i)=>{
            const clone = slide.cloneNode(true);
            clone.setAttribute("data-clone", String(slides.length - i - 1));
            this.prepend(clone);
        });
        firstSlides.forEach((slide, i)=>{
            const clone = slide.cloneNode(true);
            clone.setAttribute("data-clone", String(i));
            this.append(clone);
        });
    }
    handleSlideChange() {
        const slides = this.getSlides();
        slides.forEach((slide, i)=>{
            slide.classList.toggle("--is-active", i === this.activeSlide);
        });
        if (this.hasUpdated) this.emit("sl-slide-change", {
            detail: {
                index: this.activeSlide,
                slide: slides[this.activeSlide]
            }
        });
    }
    updateSlidesSnap() {
        const slides = this.getSlides();
        const slidesPerMove = this.slidesPerMove;
        slides.forEach((slide, i)=>{
            const shouldSnap = (i + slidesPerMove) % slidesPerMove === 0;
            if (shouldSnap) slide.style.removeProperty("scroll-snap-align");
            else slide.style.setProperty("scroll-snap-align", "none");
        });
    }
    handleAutoplayChange() {
        this.autoplayController.stop();
        if (this.autoplay) this.autoplayController.start(this.autoplayInterval);
    }
    /**
   * Move the carousel backward by `slides-per-move` slides.
   *
   * @param behavior - The behavior used for scrolling.
   */ previous(behavior = "smooth") {
        this.goToSlide(this.activeSlide - this.slidesPerMove, behavior);
    }
    /**
   * Move the carousel forward by `slides-per-move` slides.
   *
   * @param behavior - The behavior used for scrolling.
   */ next(behavior = "smooth") {
        this.goToSlide(this.activeSlide + this.slidesPerMove, behavior);
    }
    /**
   * Scrolls the carousel to the slide specified by `index`.
   *
   * @param index - The slide index.
   * @param behavior - The behavior used for scrolling.
   */ goToSlide(index, behavior = "smooth") {
        const { slidesPerPage: slidesPerPage, loop: loop } = this;
        const slides = this.getSlides();
        const slidesWithClones = this.getSlides({
            excludeClones: false
        });
        if (!slides.length) return;
        const newActiveSlide = loop ? (index + slides.length) % slides.length : (0, $17aee557d88adde4$export$7d15b64cf5a3a4c4)(index, 0, slides.length - slidesPerPage);
        this.activeSlide = newActiveSlide;
        const isRtl = this.localize.dir() === "rtl";
        const nextSlideIndex = (0, $17aee557d88adde4$export$7d15b64cf5a3a4c4)(index + (loop ? slidesPerPage : 0) + (isRtl ? slidesPerPage - 1 : 0), 0, slidesWithClones.length - 1);
        const nextSlide = slidesWithClones[nextSlideIndex];
        this.scrollToSlide(nextSlide, (0, $10aa4c887a27439c$export$ff7706047246b98b)() ? "auto" : behavior);
    }
    scrollToSlide(slide, behavior = "smooth") {
        this.pendingSlideChange = true;
        window.requestAnimationFrame(()=>{
            if (!this.scrollContainer) return;
            const scrollContainer = this.scrollContainer;
            const scrollContainerRect = scrollContainer.getBoundingClientRect();
            const nextSlideRect = slide.getBoundingClientRect();
            const nextLeft = nextSlideRect.left - scrollContainerRect.left;
            const nextTop = nextSlideRect.top - scrollContainerRect.top;
            if (nextLeft || nextTop) {
                this.pendingSlideChange = true;
                scrollContainer.scrollTo({
                    left: nextLeft + scrollContainer.scrollLeft,
                    top: nextTop + scrollContainer.scrollTop,
                    behavior: behavior
                });
            } else this.pendingSlideChange = false;
        });
    }
    render() {
        const { slidesPerMove: slidesPerMove, scrolling: scrolling } = this;
        const pagesCount = this.getPageCount();
        const currentPage = this.getCurrentPage();
        const prevEnabled = this.canScrollPrev();
        const nextEnabled = this.canScrollNext();
        const isLtr = this.localize.dir() === "ltr";
        return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
      <div part="base" class="carousel">
        <div
          id="scroll-container"
          part="scroll-container"
          class="${(0, $11177c62ab91de50$export$56cc687933817664)({
            carousel__slides: true,
            "carousel__slides--horizontal": this.orientation === "horizontal",
            "carousel__slides--vertical": this.orientation === "vertical",
            "carousel__slides--dragging": this.dragging
        })}"
          style="--slides-per-page: ${this.slidesPerPage};"
          aria-busy="${scrolling ? "true" : "false"}"
          aria-atomic="true"
          tabindex="0"
          @keydown=${this.handleKeyDown}
          @mousedown="${this.handleMouseDragStart}"
          @scroll="${this.handleScroll}"
          @scrollend=${this.handleScrollEnd}
          @click=${this.handleClick}
        >
          <slot></slot>
        </div>

        ${this.navigation ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
              <div part="navigation" class="carousel__navigation">
                <button
                  part="navigation-button navigation-button--previous"
                  class="${(0, $11177c62ab91de50$export$56cc687933817664)({
            "carousel__navigation-button": true,
            "carousel__navigation-button--previous": true,
            "carousel__navigation-button--disabled": !prevEnabled
        })}"
                  aria-label="${this.localize.term("previousSlide")}"
                  aria-controls="scroll-container"
                  aria-disabled="${prevEnabled ? "false" : "true"}"
                  @click=${prevEnabled ? ()=>this.previous() : null}
                >
                  <slot name="previous-icon">
                    <sl-icon library="system" name="${isLtr ? "chevron-left" : "chevron-right"}"></sl-icon>
                  </slot>
                </button>

                <button
                  part="navigation-button navigation-button--next"
                  class=${(0, $11177c62ab91de50$export$56cc687933817664)({
            "carousel__navigation-button": true,
            "carousel__navigation-button--next": true,
            "carousel__navigation-button--disabled": !nextEnabled
        })}
                  aria-label="${this.localize.term("nextSlide")}"
                  aria-controls="scroll-container"
                  aria-disabled="${nextEnabled ? "false" : "true"}"
                  @click=${nextEnabled ? ()=>this.next() : null}
                >
                  <slot name="next-icon">
                    <sl-icon library="system" name="${isLtr ? "chevron-right" : "chevron-left"}"></sl-icon>
                  </slot>
                </button>
              </div>
            ` : ""}
        ${this.pagination ? (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
              <div part="pagination" role="tablist" class="carousel__pagination">
                ${(0, $5160fddeae65a964$export$871de8747c9eaa88)((0, $c6a3155bf5999e32$export$d02631cccf789723)(pagesCount), (index)=>{
            const isActive = index === currentPage;
            return (0, $57a4cdd7772d1b51$export$c0bb0b647f701bb5)`
                    <button
                      part="pagination-item ${isActive ? "pagination-item--active" : ""}"
                      class="${(0, $11177c62ab91de50$export$56cc687933817664)({
                "carousel__pagination-item": true,
                "carousel__pagination-item--active": isActive
            })}"
                      role="tab"
                      id="tab-${index + 1}"
                      aria-controls="slide-${index + 1}"
                      aria-selected="${isActive ? "true" : "false"}"
                      aria-label="${isActive ? this.localize.term("slideNum", index + 1) : this.localize.term("goToSlide", index + 1, pagesCount)}"
                      tabindex=${isActive ? "0" : "-1"}
                      @click=${()=>this.goToSlide(index * slidesPerMove)}
                      @keydown=${this.handleKeyDown}
                    ></button>
                  `;
        })}
              </div>
            ` : ""}
      </div>
    `;
    }
};
$c834915fe9b039f4$export$f07c6192812bdc3c.styles = [
    (0, $e141b099bccd29d3$export$e1ac0a3ec62d1269),
    (0, $f93eeee79030574b$export$53f9b56b2cc2a838)
];
$c834915fe9b039f4$export$f07c6192812bdc3c.dependencies = {
    "sl-icon": (0, $41c94d63aaf9231c$export$ef62a86bf282441)
};
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "loop", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "navigation", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "pagination", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "autoplay", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number,
        attribute: "autoplay-interval"
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "autoplayInterval", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number,
        attribute: "slides-per-page"
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "slidesPerPage", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Number,
        attribute: "slides-per-move"
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "slidesPerMove", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)()
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "orientation", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $b5e2ce8348041b43$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "mouse-dragging"
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "mouseDragging", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".carousel__slides")
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "scrollContainer", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $815172d2438addea$export$2fa187e846a241c4)(".carousel__pagination")
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "paginationContainer", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "activeSlide", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "scrolling", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $d707a3c650256db3$export$ca000e230c0caa3e)()
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "dragging", 2);
(0, $jPx3Q.__decorateClass)([
    (0, $79d97cd93a34c8f1$export$b2b799818fbabcf3)({
        passive: true
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "handleScroll", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("loop", {
        waitUntilFirstUpdate: true
    }),
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("slidesPerPage", {
        waitUntilFirstUpdate: true
    })
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "initializeSlides", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("activeSlide")
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "handleSlideChange", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("slidesPerMove")
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "updateSlidesSnap", 1);
(0, $jPx3Q.__decorateClass)([
    (0, $f62429163a881570$export$3db5d71bdb2d5499)("autoplay")
], $c834915fe9b039f4$export$f07c6192812bdc3c.prototype, "handleAutoplayChange", 1);


// src/components/carousel/carousel.ts
var $d0ec0b4513b75c28$export$aa49f2663856f5b3 = (0, $c834915fe9b039f4$export$f07c6192812bdc3c);
(0, $c834915fe9b039f4$export$f07c6192812bdc3c).define("sl-carousel");



// src/internal/scrollend-polyfill.ts
var $dd401baab11cd891$var$debounce = (fn, delay)=>{
    let timerId = 0;
    return function(...args) {
        window.clearTimeout(timerId);
        timerId = window.setTimeout(()=>{
            fn.call(this, ...args);
        }, delay);
    };
};
var $dd401baab11cd891$var$decorate = (proto, method, decorateFn)=>{
    const superFn = proto[method];
    proto[method] = function(...args) {
        superFn.call(this, ...args);
        decorateFn.call(this, superFn, ...args);
    };
};
(()=>{
    if (typeof window === "undefined") return;
    const isSupported = "onscrollend" in window;
    if (!isSupported) {
        const pointers = /* @__PURE__ */ new Set();
        const scrollHandlers = /* @__PURE__ */ new WeakMap();
        const handlePointerDown = (event)=>{
            for (const touch of event.changedTouches)pointers.add(touch.identifier);
        };
        const handlePointerUp = (event)=>{
            for (const touch of event.changedTouches)pointers.delete(touch.identifier);
        };
        document.addEventListener("touchstart", handlePointerDown, true);
        document.addEventListener("touchend", handlePointerUp, true);
        document.addEventListener("touchcancel", handlePointerUp, true);
        $dd401baab11cd891$var$decorate(EventTarget.prototype, "addEventListener", function(addEventListener, type) {
            if (type !== "scrollend") return;
            const handleScrollEnd = $dd401baab11cd891$var$debounce(()=>{
                if (!pointers.size) this.dispatchEvent(new Event("scrollend"));
                else handleScrollEnd();
            }, 100);
            addEventListener.call(this, "scroll", handleScrollEnd, {
                passive: true
            });
            scrollHandlers.set(this, handleScrollEnd);
        });
        $dd401baab11cd891$var$decorate(EventTarget.prototype, "removeEventListener", function(removeEventListener, type) {
            if (type !== "scrollend") return;
            const scrollHandler = scrollHandlers.get(this);
            if (scrollHandler) removeEventListener.call(this, "scroll", scrollHandler, {
                passive: true
            });
        });
    }
})();


















parcelRequire("jPx3Q");








parcelRequire("jPx3Q");


var $1dff14c437db61b5$exports = {};
$1dff14c437db61b5$exports = $parcel$resolve("3FXHE");


var $5168295e6ff7f0ea$exports = {};
$5168295e6ff7f0ea$exports = $parcel$resolve("ddR3g");


var $1b4de24f257abcb0$exports = {};
$1b4de24f257abcb0$exports = $parcel$resolve("620Gg");


var $b1dc4a671a3dbe9e$exports = {};
$b1dc4a671a3dbe9e$exports = $parcel$resolve("fm3cC");


var $880effd7fa1d7da5$exports = {};
$880effd7fa1d7da5$exports = $parcel$resolve("uCCWe");


var $2b690d109b1b3a85$exports = {};
$2b690d109b1b3a85$exports = $parcel$resolve("5ccv0");


var $9925cbb9144c1f77$exports = {};
$9925cbb9144c1f77$exports = $parcel$resolve("2kW7X");


(0, $23fda3427ed4fc44$export$784ad41d332938c6)('@shoelace-style/shoelace/dist/');
const $bc604ce9849a30ff$var$bootstrapIcons = {
    'chat-left-dots': (0, (/*@__PURE__*/$parcel$interopDefault($1dff14c437db61b5$exports))),
    'exclamation-circle': (0, (/*@__PURE__*/$parcel$interopDefault($5168295e6ff7f0ea$exports))),
    'share': (0, (/*@__PURE__*/$parcel$interopDefault($1b4de24f257abcb0$exports))),
    'arrow-repeat': (0, (/*@__PURE__*/$parcel$interopDefault($b1dc4a671a3dbe9e$exports)))
};
const $bc604ce9849a30ff$var$materialIcons = {
    'event_available': (0, (/*@__PURE__*/$parcel$interopDefault($880effd7fa1d7da5$exports))),
    'health_and_safety': (0, (/*@__PURE__*/$parcel$interopDefault($2b690d109b1b3a85$exports))),
    'medication': (0, (/*@__PURE__*/$parcel$interopDefault($9925cbb9144c1f77$exports)))
};
(0, $822265300b544663$export$a482e04ad60c9b11)('default', {
    resolver: (name)=>$bc604ce9849a30ff$var$bootstrapIcons[name] ?? `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.13.1/icons/${name}.svg`
});
(0, $822265300b544663$export$a482e04ad60c9b11)('material', {
    resolver: (name)=>{
        if ($bc604ce9849a30ff$var$materialIcons[name]) return $bc604ce9849a30ff$var$materialIcons[name];
        const match = name.match(/^(.*?)(_(round|sharp))?$/);
        return `https://cdn.jsdelivr.net/npm/@material-icons/svg@1.0.33/svg/${match[1]}/${match[3] || 'outline'}.svg`;
    },
    mutator: (svg)=>svg.setAttribute('fill', 'currentColor')
});


//# sourceMappingURL=root.c194082d.js.map
